webpackJsonp([29],{

/***/ "0FkX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Al0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6lg3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "production/v2.18.15/img/corporate.0d4a1b2.png";

/***/ }),

/***/ "CPGk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isBrowser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return removeStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return uuid; });
/* harmony export (immutable) */ __webpack_exports__["c"] = hashUnique;
/* unused harmony export isObject */
/* harmony export (immutable) */ __webpack_exports__["f"] = isPlainObject;
/* harmony export (immutable) */ __webpack_exports__["e"] = isPlainNumber;
/* unused harmony export isPlainString */
/* unused harmony export isPlainBoolean */
/* unused harmony export isPlainArray */
/* unused harmony export isPlainFunction */
/* unused harmony export isEmptyObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


/**
 * 检测浏览器是否IE
 */
var isBrowser = function isBrowser() {
  // 取得浏览器的userAgent字符串
  var userAgent = navigator.userAgent;
  // 判断是否Opera浏览器
  var isOpera = userAgent.indexOf("Opera") > -1;
  if (isOpera) {
    return 'Opera';
  }

  // 判断是否Firefox浏览器
  if (userAgent.indexOf('Firefox') > -1) {
    return 'FF';
  }

  // 判断是否Chrome浏览器
  if (userAgent.indexOf('Chrome') > -1) {
    return 'Chrome';
  }

  // 判断是否Safari浏览器
  if (userAgent.indexOf('Safari') > -1) {
    return 'Safari';
  }
  // 判断是否IE浏览器
  if (userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera || userAgent.indexOf('rv:11.0) like Gecko') > -1) {
    return 'IE';
  }
};
/**
 * 存储 localStorage
 */
var setStore = function setStore(name, content) {
  if (!name) {
    return;
  }
  if (typeof content !== 'string') {
    content = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取 localStorage
 */
var getStore = function getStore(name) {
  if (!name) return;
  return JSON.parse(window.localStorage.getItem(name));
};

/**
 * 删除 localStorage
 */
var removeStore = function removeStore(name) {
  if (!name) return;
  return window.localStorage.removeItem(name);
};

/**
 * 时间格式化
 */

var formatTime = function formatTime(date, mode) {
  if (!date) {
    return '';
  }
  var d0 = new Date(0);
  var d1 = new Date('1970/01/01 08:00:00');
  date = parseInt(date) + (d1.getTime() - d0.getTime()) / 1000;
  var d = new Date(parseInt(date) * 1000);
  var format = mode;
  var o = {
    'M+': d.getMonth() + 1, // month
    'd+': d.getDate(), // day
    'h+': d.getHours(), // hour
    's+': d.getSeconds(), // second
    'm+': d.getMinutes(), // minute
    'q+': Math.floor((d.getMonth() + 3) / 3), // quarter
    'S': d.getMilliseconds() // millisecond
  };
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (d.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return format;
};

// UUID 生成 type 区分那个第三方 'ding' 'weixin'
var uuid = function uuid(type) {
  var s = [];
  var hexDigits = '0123456789abcdef';
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-';

  var uuid = s.join('');
  return type + uuid;
};
// /**
//  * Created by josh on 16/11/8.
//  */
//
// /*
//  *  克隆
//  *   Object.create(obj);
//  *   * obj 作为新创建对象的原型。
//  *
//  *   ** Object.create(null);   === let obj
//  *   ** Object.create(Object.prototype);   === let obj = {};
//  *   ** const A = {};   Object.getPrototypeOf( Object.create(A) ) === A  TRUE
//  * */
//
// /*
//  * cloneObj 数组深度克隆
//  * */
// export function deepCloneObj(obj) {
//     let str,
//         newobj = obj.constructor === Array ? [] : {};
//     // let arr = new Array() obj 是Array构造函数实例
//     if (typeof obj !== 'object') {
//         return;
//     } else if (window.JSON) {
//         str = JSON.stringify(obj);
//         newobj = JSON.parse(str);
//     } else {
//         for (let i in obj) {
//             newobj[i] = typeof obj[i] === 'object' ? deepCloneObj(obj[i]) : obj[i];
//         }
//     }
//     return newobj;
// }
//
/*
 * 单数组去重复 [a, b,c,d]
 * 空间换时间
 * */
function hashUnique(arr) {
  var result = [];
  var hash = {};
  for (var i = 0, elem; (elem = arr[i]) != null; i++) {
    if (!hash[elem]) {
      result.push(elem);
      hash[elem] = true;
    }
  }
  return result;
}

//
// /*
//  * 单数组去重复 [a, b,c,d]
//  * 关键字 indexOf
//  * */
// export function indexUnique(array) {
//     let result = [array[0]]; //结果数组
//     //从第二项开始遍历
//     for (let i = 1; i < array.length; i++) {
//         //如果当前数组的第i项在当前数组中第一次出现的位置不是i，
//         //那么表示第i项是重复的，忽略掉。否则存入结果数组
//         if (array.indexOf(array[i]) == i) {
//             result.push(array[i])
//         };
//     }
//     return result;
// }
//
// /*
//  * 单数组去重复 [a, b,c,d]
//  * 将相同的值相邻，然后遍历去除重复值
//  * */
// export function sortUnique(array) {
//     array.sort();
//     let result = [array[0]];
//     for (let i = 1; i < array.length; i++) {
//         if (array[i] !== result[result.length - 1]) {
//             result.push(array[i]);
//         }
//     }
//     return result;
// }
//
// /*
//  * 单数组去重复 [a, b, a, d,a]
//  * 思路：获取没重复的最右一值放入新数组
//  * */
// eachUnique([1, 2, 3, 1, 11, 2, 3, 4, 5, 6, 3, 2, 3, 3, 1, 2, 3, 5, 3])
// export function eachUnique(array) {
//     let result = [];
//     for (let i = 0, l = array.length; i < l; i++) {
//         for (let j = i + 1; j < l; j++) {
//             if (array[i] === array[j]) {
//                 j = ++i;
//             }
//         }
//         result.push(array[i]);
//     }
//     return result;
// }
//
// /*
//  * Object 深度合并
//  * jquery.extend
//  * */
// export function extend(obj, copyArray) {
//     let src,
//         copyIsArray,
//         isArray,
//         copy,
//         name,
//         clone,
//         target = typeof obj == 'object' ? obj : {}
//
//     if (copyArray != null) {
//
//         for (name in copyArray) {
//
//             src = target[name]; //** 数组一
//             copy = copyArray[name]; //** 数组二
//
//             //** 防止无限循环
//             if (target === copy) {
//                 continue;
//             }
//
//             const isObject = copyIsArray = Array.isArray(copy) //**数组
//
//             if (copy && ((typeof copy == 'object' && !isObject) || copyIsArray)) {
//                 if (copyIsArray) {
//                     copyIsArray = false;
//                     isArray = Array.isArray(src)
//                     clone = src && isArray ? src : [];
//                 } else {
//                     clone = src && typeof src == 'object' ? src : {};
//                 }
//
//                 target[name] = extend(clone, copy, booble, callback);
//
//             } else if (copy !== undefined) {
//                 target[name] = copy;
//             }
//
//         }
//
//     }
//
//     return target;
// }
//
// /**
//  * Check whether the object has the property.
//  * 方法会返回一个布尔值，其用来判断某个对象是否含有指定的属性
//  */
// const hasOwnProperty = Object.prototype.hasOwnProperty;
// export function hasOwn(obj, key) {
//     return hasOwnProperty.call(obj, key)
// }
//
/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 *
 */
function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj)) === 'object';
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 *  console.log(Object.prototype.toString.call(123)) //[object Number]
 console.log(Object.prototype.toString.call('123')) //[object String]
 console.log(Object.prototype.toString.call(undefined)) //[object Undefined]
 console.log(Object.prototype.toString.call(true)) //[object Boolean]
 console.log(Object.prototype.toString.call({})) //[object Object]
 console.log(Object.prototype.toString.call([])) //[object Array]
 console.log(Object.prototype.toString.call(function(){})) //[object Function]
 */
var toString = Object.prototype.toString;
var OBJECT_OBJECT = '[object Object]';
var OBJECT_NUMBER = '[object Number]';
var OBJECT_STRING = '[object String]';
var OBJECT_BOOLEAN = '[object Boolean]';
var OBJECT_ARRAY = '[object Array]';
var OBJECT_FUNCTION = '[object Function]';

function isPlainObject(obj) {
  return toString.call(obj) === OBJECT_OBJECT;
}

function isPlainNumber(obj) {
  return toString.call(obj) === OBJECT_NUMBER;
}

function isPlainString(obj) {
  return toString.call(obj) === OBJECT_STRING;
}

function isPlainBoolean(obj) {
  return toString.call(obj) === OBJECT_BOOLEAN;
}

function isPlainArray(obj) {
  return toString.call(obj) === OBJECT_ARRAY;
}

function isPlainFunction(obj) {
  return toString.call(obj) === OBJECT_FUNCTION;
}

/**
 *obj = object
 * false //不为空
 * true //为空
 */
function isEmptyObject(obj) {
  for (var name in obj) {
    return false;
  }
  return true;
}

/***/ }),

/***/ "GbM2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JYnv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by josh on 17/08/11.
 * 路由元信息 meta 字段
 * path: string;
 * component?: Component;
 * name?: string; // for named routes (命名路由)
 * components?: { [name: string]: Component }; // for named views (命名视图组件)
 * redirect?: string | Location | Function; //路由重定向
 * alias?: string | Array<string>; 别名
 * children?: Array<RouteConfig>; // for nested routes
 * beforeEnter?: (route: Route, redirect: Function, next: Function) => void; //路由钩子
 * meta?: any; //参数
 */
// 登录
// const home = resolve => require(['../views/home.vue'], resolve);
// const subRouter = resolve => require(['../components/router.vue'], resolve);

var subRouter = function subRouter() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "GkLK"));
};

// 首页
var home = function home() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "aRPN"));
};

// 联系人管理
var contacts = function contacts() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, "TP4D"));
};

// 流程签署
var signFlow = function signFlow() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "460M"));
};

var Signer = function Signer() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "np1D"));
};

// 我的合同
var word = function word() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "ae+I"));
};
// 批量签署
var batch = function batch() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "BwU3"));
};
// 信息管理
var info = function info() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "TYJL"));
};

// 印章管理
var seal = function seal() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "Scb5"));
};
// 添加印章
var addSeal = function addSeal() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "Ol9t"));
};
// 编辑印章
var editSeal = function editSeal() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "EegP"));
};
// 合同模板编辑页面
var templateEdit = function templateEdit() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "59nK"));
};
// 我的模板
var myTemplate = function myTemplate() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "sKZC"));
};
// 合同预览
var templatePreview = function templatePreview() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "HUe1"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: 'index',
  name: 'Index',
  meta: {
    alias: '首页'
  },
  component: home
}, {
  path: 'word',
  name: 'Word',
  meta: {
    alias: '我的合同'
  },
  component: word
}, {
  path: 'template',
  name: 'Template',
  meta: {
    alias: '我的模板'
  },
  component: myTemplate
}, {
  path: 'user',
  meta: {
    alias: '用户中心'
  },
  component: subRouter,
  children: [
  // 默认
  {
    path: '',
    name: 'User',
    redirect: 'info' // 重定向到 info
  }, {
    path: 'info',
    name: 'Info',
    meta: {
      alias: '信息管理'
    },
    component: info
  }, {
    path: 'seal',
    name: 'Seal',
    meta: {
      alias: '印章管理'
    },
    component: seal
  }, {
    path: 'addSeal',
    name: 'addSeal',
    component: addSeal
  }, {
    path: 'editSeal',
    name: 'editSeal',
    component: editSeal
  }, {
    path: 'contacts',
    name: 'Contacts',
    meta: {
      alias: '联系人管理'
    },
    component: contacts
  }]
}, {
  path: 'flow',
  name: 'Flow',
  component: signFlow
},
// {
//   path: 'flowback',
//   name: 'Flowback',
//   component: () => import ('../views/sign/flow-back.vue')
// },
{
  path: 'signer',
  name: 'Signer',
  component: Signer
}, {
  path: 'batch',
  name: 'Batch',
  meta: {
    alias: '批量签署'
  },
  component: batch
},
// {
//   path: 'sign',
//   meta: {},
//   component: subRouter,
//   children: []
// },
{
  path: 'templateEdit',
  name: 'TemplateEdit',
  component: templateEdit
}, {
  path: 'templatePreview',
  name: 'TemplatePreview',
  component: templatePreview
}]);

/***/ }),

/***/ "LoU1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S/Ce":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOCAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SOURCE; });
/**
 * 定义请求地址
 * @param local：本地mock
 * @param develop: 本地开发
 * @param feature: 测试环境
 * @param prepub: 预发环境
 * @param production: 线上环境
 */

var config = {
  local: 'http://127.0.0.1:3000/api',
  develop: 'http://121.40.239.205:8000/service',
  // develop: 'http://120.26.93.6:8084/service',
  feature: 'http://121.40.239.205:8000/service',
  prepub: 'https://preapi.tsign.cn/service',
  production: 'https://api.tsign.cn/service'
};

var customConfig = {
  'esign': ['localhost', 'web.dev.cn', 'test.web.tsign.cn', 'preweb.tsign.cn', 'web.tsign.cn'],
  'yonyou': ['yonyoutest.web.tsign.cn', 'yonyouweb.tsign.cn', 'yonyoupreweb.tsign.cn']
};

var api = function api() {
  var DEVELOP = false || false;
  var FEATURE = false || false;
  var PREPUB = false || false;
  var PRODUCTION = true || false;

  if (DEVELOP) {
    // 测试环境
    return config.develop;
  }
  if (FEATURE) {
    // 线上环境
    return config.feature;
  }
  if (PREPUB) {
    // 测试环境
    return config.prepub;
  }
  if (PRODUCTION) {
    // 线上环境
    return config.production;
  }
  return config.local;
};

var customSource = function customSource() {
  var hostname = window.location.hostname;
  //
  var sourcename = 'esign';
  // ip 地址全部走 ‘esign’
  var reg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/; // ip地址
  if (reg.test(hostname)) {
    return sourcename;
  }

  for (var source in customConfig) {
    if (customConfig[source].indexOf(hostname) > -1) {
      sourcename = source;
      break;
    }
  }
  return sourcename;
};

var API = api();
var SOURCE = customSource();
var LOCAL = config.local;



/***/ }),

/***/ "VVcI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WcvB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_config_js__ = __webpack_require__("rvz5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nprogress__ = __webpack_require__("Y81h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_nprogress__);




// import { Message } from 'element-ui';

// TODO: HTTP 配置
var resource = function resource() {
  // 添加一个请求拦截器
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.withCredentials = true;
  // axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
  // axios.defaults.baseURL = 'https://api.example.com';
  // axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
  // axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (request) {
    // TODO: 请求发送前的处理逻辑
    // request.headers()
    // request.url = request.url + '?' + Date.now();
    // 过滤不需要 顶部进度条
    if (request.url.lastIndexOf('multipart') == -1) {
      // NProgress.inc(0.2);
    }

    return request;
  }, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
  // 添加一个响应拦截器
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
    // TODO: 返回数据前的处理逻辑
    __WEBPACK_IMPORTED_MODULE_3_nprogress___default.a.done();
    if (response.data.errCode === 21000) {
      setTimeout(function () {
        if (__WEBPACK_IMPORTED_MODULE_2__lib_config_js__["d" /* SOURCE */] == 'esign') {
          // this.$router.push({ path: '/login' });
          window.location.href = '/login';
          return false;
        }
        window.location.href = response.data.data.redirectUrl;
      }, 500);
    }
    return response;
  }, function (error) {
    if (error.response) {
      // 请求已经发出，但是服务器响应返回的状态吗不在2xx的范围内
      // console.log(error.response, 'error.response');
      // console.log(error.response.data, 'error.response.data');
      // console.log(error.response.status, 'error.response.status');
      // console.log(error.response.header, 'error.response.header');
      // console.log(error.response.ok, 'error.response.ok');
    } else {
        // 一些错误是在设置请求的时候触发
      }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (resource);

/***/ }),

/***/ "lGzU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var getters_namespaceObject = {};
__webpack_require__.d(getters_namespaceObject, "sealColor", function() { return sealColor; });
__webpack_require__.d(getters_namespaceObject, "sealType", function() { return sealType; });
__webpack_require__.d(getters_namespaceObject, "sealShowUrl", function() { return sealShowUrl; });
__webpack_require__.d(getters_namespaceObject, "templateSearchContent", function() { return templateSearchContent; });
__webpack_require__.d(getters_namespaceObject, "templateCurrentPage", function() { return templateCurrentPage; });
__webpack_require__.d(getters_namespaceObject, "batchList", function() { return batchList; });
__webpack_require__.d(getters_namespaceObject, "filesUploadOther", function() { return filesUploadOther; });
var eleValidate_namespaceObject = {};
__webpack_require__.d(eleValidate_namespaceObject, "VaName", function() { return VaName; });
__webpack_require__.d(eleValidate_namespaceObject, "VaLength", function() { return VaLength; });
__webpack_require__.d(eleValidate_namespaceObject, "ValidateGLName", function() { return ValidateGLName; });
__webpack_require__.d(eleValidate_namespaceObject, "ValidateGLPassword", function() { return ValidateGLPassword; });
__webpack_require__.d(eleValidate_namespaceObject, "ValidateChekPassword", function() { return ValidateChekPassword; });
__webpack_require__.d(eleValidate_namespaceObject, "VaPhone", function() { return VaPhone; });
__webpack_require__.d(eleValidate_namespaceObject, "VaCode", function() { return VaCode; });
__webpack_require__.d(eleValidate_namespaceObject, "IdAge", function() { return IdAge; });
__webpack_require__.d(eleValidate_namespaceObject, "VaId", function() { return VaId; });
__webpack_require__.d(eleValidate_namespaceObject, "VaBankNum", function() { return VaBankNum; });
__webpack_require__.d(eleValidate_namespaceObject, "VaIsNum", function() { return VaIsNum; });
__webpack_require__.d(eleValidate_namespaceObject, "VaIsNumLess1", function() { return VaIsNumLess1; });
__webpack_require__.d(eleValidate_namespaceObject, "VaIsNumLess2", function() { return VaIsNumLess2; });
__webpack_require__.d(eleValidate_namespaceObject, "VaPagingSeal", function() { return VaPagingSeal; });
__webpack_require__.d(eleValidate_namespaceObject, "VaIsBlank", function() { return VaIsBlank; });
__webpack_require__.d(eleValidate_namespaceObject, "VaCheckboxBlank", function() { return VaCheckboxBlank; });
__webpack_require__.d(eleValidate_namespaceObject, "VaPhotoBlank", function() { return VaPhotoBlank; });
__webpack_require__.d(eleValidate_namespaceObject, "checkPhoneEmail", function() { return checkPhoneEmail; });
__webpack_require__.d(eleValidate_namespaceObject, "checkNickName", function() { return checkNickName; });
__webpack_require__.d(eleValidate_namespaceObject, "personalRealName", function() { return personalRealName; });
__webpack_require__.d(eleValidate_namespaceObject, "checkOrganCode", function() { return checkOrganCode; });
__webpack_require__.d(eleValidate_namespaceObject, "checkOrganCode3", function() { return checkOrganCode3; });
__webpack_require__.d(eleValidate_namespaceObject, "checkRegCode", function() { return checkRegCode; });
__webpack_require__.d(eleValidate_namespaceObject, "checkNameLength", function() { return checkNameLength; });
__webpack_require__.d(eleValidate_namespaceObject, "checkNameLength2", function() { return checkNameLength2; });
__webpack_require__.d(eleValidate_namespaceObject, "checkNameLength3", function() { return checkNameLength3; });
__webpack_require__.d(eleValidate_namespaceObject, "checkSmId", function() { return checkSmId; });
__webpack_require__.d(eleValidate_namespaceObject, "checkPay", function() { return checkPay; });
__webpack_require__.d(eleValidate_namespaceObject, "checkPersonSeal", function() { return checkPersonSeal; });
__webpack_require__.d(eleValidate_namespaceObject, "checkSealWH", function() { return checkSealWH; });
__webpack_require__.d(eleValidate_namespaceObject, "fileName", function() { return fileName; });

// EXTERNAL MODULE: ./node_modules/_@babel_polyfill@7.0.0@@babel/polyfill/lib/index.js
var lib = __webpack_require__("ogd/");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/es6-promise/auto.js
var auto = __webpack_require__("MU8w");
var auto_default = /*#__PURE__*/__webpack_require__.n(auto);

// EXTERNAL MODULE: ./node_modules/fetch-ie8/fetch.js
var fetch_ie8_fetch = __webpack_require__("dBtJ");
var fetch_default = /*#__PURE__*/__webpack_require__.n(fetch_ie8_fetch);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/admin/App.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
  props: {},
  components: {},
  beforeCreate: function beforeCreate() {},
  created: function created() {},
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  beforeUpdate: function beforeUpdate() {},
  updated: function updated() {},
  beforeDestroy: function beforeDestroy() {},
  destroyed: function destroyed() {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    // 在当前路由改变，但是该组件被复用时调用
    // 举例来说，对于一个带有动态参数的路径 /foo/:id，在 /foo/1 和 /foo/2 之间跳转的时候，
    // 由于会渲染同样的 Foo 组件，因此组件实例会被复用。而这个钩子就会在这个情况下被调用。
    // 可以访问组件实例 `this`
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
  },
  data: function data() {
    return {};
  },

  mixins: [],
  methods: {},
  computed: {},
  watch: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9067550c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-h100"},[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var admin_App = (esExports);
// CONCATENATED MODULE: ./src/pages/admin/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("VVcI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  admin_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pages_admin_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/pages/admin/store/action.js
/* harmony default export */ var action = ({});
// CONCATENATED MODULE: ./src/pages/admin/store/getters.js
var sealColor = function sealColor(state) {
  return state.sealColor;
};
var sealType = function sealType(state) {
  return state.sealType;
};
var sealShowUrl = function sealShowUrl(state) {
  return state.sealShowUrl;
};
var templateSearchContent = function templateSearchContent(state) {
  return state.templateSearchContent;
};
var templateCurrentPage = function templateCurrentPage(state) {
  return state.templateCurrentPage;
};
var batchList = function batchList(state) {
  return state.batchList;
};
var filesUploadOther = function filesUploadOther(state) {
  return state.filesUploadOther;
};
// CONCATENATED MODULE: ./src/pages/admin/store/state.js
var state_state = {
  sealColor: 'RED', // 印章颜色
  sealType: '', // 印章类型
  sealShowUrl: '', // 手绘印章
  perAddType: '', // 个人印章 手绘模板 类型
  infoDateStore: '', // 用户信息
  templateSearchContent: '', // 模板搜索内容
  templateCurrentPage: 1, // 模板list当前页面，
  // 批量签署list
  batchList: [],
  filesUploadOther: ''
};

/* harmony default export */ var store_state = (state_state);
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/pages/admin/store/mutation-types.js
// 模块名称__数据描述_数据操作. BEM
var SEAL_TYPE = 'SEAL_TYPE';
var SEAL_COLOR = 'SEAL_COLOR';
var SEAL_FORM = 'SEAL_FORM';
var SEAL_SHOW_URI = 'SEAL_SHOW_URI';
var PER_ADD_TYPE = 'PER_ADD_TYPE';
var INFO_GET_STORE = 'INFO_GET_STORE';
var INFO_SET_STORE = 'INFO_SET_STORE';
// 模板搜索内容 templateSearchContent
var TEMPLATE_SEARCH_CONTENT = 'TEMPLATE_SEARCH_CONTENT';
// 模板 当前 page templateCurrentPage
var TEMPLATE_CURRENT_PAGE = 'TEMPLATE_CURRENT_PAGE';
// 批量签署的数据
var BATCH_LIST = 'BATCH_LIST';
// 其他页面上传文件 files保存
var FILES_UPLOAD_OTHER = 'FILES_UPLOAD_OTHER';
// EXTERNAL MODULE: ./src/lib/util.js
var util = __webpack_require__("CPGk");

// CONCATENATED MODULE: ./src/pages/admin/store/mutations.js


var _mutations;




var mutations = (_mutations = {}, defineProperty_default()(_mutations, SEAL_TYPE, function (state, sealType) {
  state.sealType = sealType;
}), defineProperty_default()(_mutations, SEAL_COLOR, function (state, sealColor) {
  state.sealColor = sealColor;
}), defineProperty_default()(_mutations, SEAL_SHOW_URI, function (state, sealShowUrl) {
  state.sealShowUrl = sealShowUrl;
}), defineProperty_default()(_mutations, PER_ADD_TYPE, function (state, perAddType) {
  state.perAddType = perAddType;
}), defineProperty_default()(_mutations, INFO_SET_STORE, function (state, _ref) {
  var key = _ref.key,
      userInfo = _ref.userInfo;

  if (state.infoDateStore === '') {
    state.infoDateStore = Object(util["b" /* getStore */])(key ? key : 'userInfo');
  } else {
    state.infoDateStore = userInfo;
    Object(util["h" /* setStore */])(key ? key : 'userInfo', userInfo);
  }
}), defineProperty_default()(_mutations, TEMPLATE_SEARCH_CONTENT, function (state, templateSearchContent) {
  state.templateSearchContent = templateSearchContent;
}), defineProperty_default()(_mutations, TEMPLATE_CURRENT_PAGE, function (state, templateCurrentPage) {
  state.templateCurrentPage = templateCurrentPage;
}), defineProperty_default()(_mutations, BATCH_LIST, function (state, list) {
  state.batchList = list;
}), defineProperty_default()(_mutations, FILES_UPLOAD_OTHER, function (state, event) {
  state.filesUploadOther = event;
}), _mutations);
/* harmony default export */ var store_mutations = (mutations);
// CONCATENATED MODULE: ./src/pages/admin/store/index.js






// import account from './modules/account';

vue_esm["default"].use(vuex_esm["a" /* default */]);

vue_esm["default"].config.warnExpressionErrors = true; // 数据为未出来时警告

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
    actions: action,
    getters: getters_namespaceObject,
    state: store_state,
    mutations: store_mutations,
    strict: "production" !== 'production' // 严格模式
    // plugins:[]
}));
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./src/lib/config.js
var lib_config = __webpack_require__("rvz5");

// EXTERNAL MODULE: ./src/pages/admin/router/main.js
var main = __webpack_require__("JYnv");

// CONCATENATED MODULE: ./src/pages/admin/router/attestation.js
/**
 * Created by josh on 17/08/11.
 * 路由元信息 meta 字段
 * path: string;
 * component?: Component;
 * name?: string; // for named routes (命名路由)
 * components?: { [name: string]: Component }; // for named views (命名视图组件)
 * redirect?: string | Location | Function; //路由重定向
 * alias?: string | Array<string>; 别名
 * children?: Array<RouteConfig>; // for nested routes
 * beforeEnter?: (route: Route, redirect: Function, next: Function) => void; //路由钩子
 * meta?: any; //参数
 */
// 登录
// const home = resolve => require(['../views/home.vue'], resolve);
// const subRouter = resolve => require(['../components/router.vue'], resolve);

// 个人实名
var personalName = function personalName() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "DoJG"));
};
// 个人人工实名
var artPersonalMsg = function artPersonalMsg() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "E/kz"));
};
// 企业实名
var groupName = function groupName() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "Qt3f"));
};
// 企业人工 信息
var artGroupMsg = function artGroupMsg() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, "o9mg"));
};
// 企业人工 照片
var artGroupPhoto = function artGroupPhoto() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, "AIG/"));
};
// 企业人工 银行信息
var artGroupBank = function artGroupBank() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, "uLnN"));
};
// 个人芝麻认证二维码页面
var personQrcode = function personQrcode() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "/55U"));
};
// 实名认证结果
var approveResult = function approveResult() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "Svi6"));
};

/* harmony default export */ var attestation = ([
// 个人实名
{
  path: 'personalName',
  name: 'PersonalName',
  component: personalName
},
// 个人人工实名
{
  path: 'artpersonalMsg',
  name: 'artpersonalMsg',
  component: artPersonalMsg
},
// 企业实名认证
{
  path: 'groupName',
  name: 'GroupName',
  component: groupName
},
// 企业人工实名 信息
{
  path: 'artGroupMsg',
  name: 'ArtGroupMsg',
  component: artGroupMsg
},
// 企业人工实名 图片
{
  path: 'artGroupPhoto',
  name: 'ArtGroupPhoto',
  component: artGroupPhoto
},
// 个人芝麻认证二维码
{
  path: 'personQrcode',
  name: 'PersonQrcode',
  component: personQrcode
},
// 企业人工实名 银行信息
{
  path: 'artGroupBank',
  name: 'ArtGroupBank',
  component: artGroupBank
},
// 实名认证结果
{
  path: 'approveResult',
  name: 'ApproveResult',
  component: approveResult
}]);
// CONCATENATED MODULE: ./src/pages/admin/router/menu.js




var menu__this = this;

/**
 * Created by josh on 17/08/11.
 * 路由元信息 meta 字段
 * path: string;
 * component?: Component;
 * name?: string; // for named routes (命名路由)
 * components?: { [name: string]: Component }; // for named views (命名视图组件)
 * redirect?: string | Location | Function; //路由重定向
 * alias?: string | Array<string>; 别名
 * children?: Array<RouteConfig>; // for nested routes
 * beforeEnter?: (route: Route, redirect: Function, next: Function) => void; //路由钩子
 * meta?: any; //参数
 */



// 路由入口
var mainRouter = function mainRouter() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "ZkWA"));
};
// 二级路由入口
var subRouter = function subRouter() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "GkLK"));
};
// 注册
var enroll = function enroll() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "fzWV"));
};
// 注册结果
var registResult = function registResult() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "6NH3"));
};
// 修改密码
var retrievePassword = function retrievePassword() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "01lm"));
};
// 引导页面
// const guide = () =>
//   import ('../views/guide/guide.vue');

// fetch 配置环境
var menu_option = {
  mode: 'cors',
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json'
  },
  method: 'GET'
};

/* harmony default export */ var menu = ([{
  path: '/main',
  component: mainRouter,
  children: main["a" /* default */],
  beforeEnter: function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(to, from, next) {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch(lib_config["a" /* API */] + '/rest/v1/company/configuration/' + lib_config["d" /* SOURCE */], menu_option).then(function (response) {
                return response.json();
              }).then(function (responseData) {
                if (responseData.data) {
                  window.sessionStorage.setItem('customizeInfo', stringify_default()(responseData.data));
                } else {
                  // console.log('定制---请求没有数据');
                  window.sessionStorage.clear();
                }
              }, function (response) {
                // console.log('定制---请求失败');
                window.sessionStorage.clear();
              });

            case 2:

              fetch(lib_config["a" /* API */] + '/rest/v1/login/check?source=' + lib_config["d" /* SOURCE */] + '&t=' + Date.now(), menu_option).then(function (response) {
                return response.json();
              }).then(function (responseData) {
                // console.log('main-session接口请求成功');
                if (!responseData.data.isLogined) {
                  // console.log('main-session失效跳转');
                  if (lib_config["d" /* SOURCE */] == 'esign') {
                    next({ path: '/login' });
                  } else {
                    next(false);
                    window.location.href = responseData.data.redirectUrl;
                  }
                  return false;
                }
                // console.log('main-session验证成功');
                next();
              }, function (response) {
                // console.log('main-session请求失败');
                next(false);
              });

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, menu__this);
    }));

    return function beforeEnter(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }()
}, {
  path: '/attestation',
  component: subRouter,
  children: attestation,
  beforeEnter: function beforeEnter(to, from, next) {
    // console.log('进入attestation组件');
    fetch(lib_config["a" /* API */] + '/rest/v1/login/check?source=' + lib_config["d" /* SOURCE */] + '&t=' + Date.now(), menu_option).then(function (response) {
      return response.json();
    }).then(function (responseData) {
      // console.log('attestation-session接口请求成功');
      if (!responseData.data.isLogined) {
        // console.log('attestation-session失效跳转');
        if (lib_config["d" /* SOURCE */] == 'esign') {
          next({ path: '/login' });
        } else {
          next(false);
          window.location.href = responseData.data.redirectUrl;
        }
        return false;
      }
      // console.log('attestation-session验证成功');
      next();
    }, function (response) {
      // console.log('attestation-session请求失败');
      next(false);
    });
  }
},
// 找回密码 retrievePassword
{
  path: '/retrievePassword',
  name: 'RetrievePassword',
  component: retrievePassword
},
// 企业和个人注册 enroll
{
  path: '/enroll',
  component: subRouter,
  children: [{
    path: '/',
    name: 'Enroll',
    component: enroll
  },
  // 注册结果 registResult
  {
    path: 'registResult',
    name: 'RegistResult',
    component: registResult
  }]
}]);
// CONCATENATED MODULE: ./src/pages/admin/router/index.js






vue_esm["default"].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'ui-router-active',
  // scrollBehavior: () => ({ y: 0 }),
  // 只在 HTML5 history 模式下可用
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    to.matched.some(function (m) {
      // console.log(m);
    });
    return {
      y: 0
    };
  },
  routes: [{
    path: '/',
    redirect: function redirect(to) {
      if (lib_config["d" /* SOURCE */] != 'esign') {
        window.location.href = 'yonyou.html';
      } else {
        return { path: '/main/index' };
      }
    }
    // beforeEnter: (to, from, next) => {}
  }, {
    name: 'Login',
    path: '/login',
    meta: {},
    component: function component(resolve) {
      __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("z4St")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }].concat(toConsumableArray_default()(generateRoutesFromMenu(menu)), [{
    path: '*',
    redirect: function redirect(to) {
      // window.location.href = "404.vue"
    }
  }])
});

router.beforeEach(function (to, from, next) {
  // console.log('router.beforeEach, 异步组件还没有加载', to);
  // console.log(to, 'to');
  // console.log(from, 'from');
  next();
});

router.beforeResolve(function (to, from, next) {
  // console.log('router.beforeResolve-此时异步组件已经加载完成');
  // console.log('router.beforeResolve');
  // console.log(to, 'to.beforeResolve');
  // console.log(from, 'from.beforeResolve');
  next();
});

router.afterEach(function (to, from, next) {
  // console.log('router.afterEach');
});

// *** 遍历
function generateRoutesFromMenu() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var routes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  for (var i = 0, l = menu.length; i < l; i++) {
    var item = menu[i];
    if (item.path) {
      routes.push(item);
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes);
    }
  }
  return routes;
}

/* harmony default export */ var admin_router = (router);
// EXTERNAL MODULE: ./node_modules/_element-ui@2.4.9@element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("9ab0");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/plugin-api/packages/button/src/button.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var src_button = ({
  name: 'EButton',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    size: String,
    block: String,
    icon: {
      type: String,
      default: ''
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    loading: Boolean,
    disabled: Boolean
  },

  methods: {
    handleClick: function handleClick(evt) {
      this.$emit('click', evt);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e515fc3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugin-api/packages/button/src/button.vue
var button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:[
    _vm.type ? 'btn-' + _vm.type : '',
    _vm.size ? 'btn-' + _vm.size : '',
    _vm.block ? 'btn-' + _vm.block : '',
    {
      'disabled': _vm.disabled ? _vm.disabled : _vm.loading
    }
  ],attrs:{"disabled":_vm.disabled ? _vm.disabled : _vm.loading,"type":_vm.nativeType},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('i',{staticClass:"el-icon-loading"}):_vm._e(),_vm._v(" "),(_vm.icon && !_vm.loading)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(" "),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])}
var button_staticRenderFns = []
var button_esExports = { render: button_render, staticRenderFns: button_staticRenderFns }
/* harmony default export */ var button_src_button = (button_esExports);
// CONCATENATED MODULE: ./src/plugin-api/packages/button/src/button.vue
function button_injectStyle (ssrContext) {
  __webpack_require__("LoU1")
}
var button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var button___vue_template_functional__ = false
/* styles */
var button___vue_styles__ = button_injectStyle
/* scopeId */
var button___vue_scopeId__ = "data-v-3e515fc3"
/* moduleIdentifier (server only) */
var button___vue_module_identifier__ = null
var button_Component = button_normalizeComponent(
  src_button,
  button_src_button,
  button___vue_template_functional__,
  button___vue_styles__,
  button___vue_scopeId__,
  button___vue_module_identifier__
)

/* harmony default export */ var packages_button_src_button = (button_Component.exports);

// CONCATENATED MODULE: ./src/plugin-api/packages/button/index.js
/**
 * Created by josh on 2017/8/11.
 */



/* istanbul ignore next */
packages_button_src_button.install = function (Vue) {
  Vue.component(packages_button_src_button.name, packages_button_src_button);
};

/* harmony default export */ var packages_button = (packages_button_src_button);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/plugin-api/packages/button/src/button-group.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var button_group = ({
    name: 'EButtonGroup',
    props: {
        initData: {
            type: Array,
            required: true,
            default: function _default() {
                return [];
            }
        },
        size: String
    },
    data: function data() {
        return {
            tabCur: 0
        };
    },

    methods: {
        handleClick: function handleClick(v) {
            this.tabCur = v;
            this.$emit('eventButtonGroup', v);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb5a5ea8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugin-api/packages/button/src/button-group.vue
var button_group_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group",class:[
     _vm.size ? 'btn-group-' + _vm.size : '']},_vm._l((_vm.initData),function(item,index){return _c('ngmm-button',{key:index,attrs:{"icon":item.icon || '',"disabled":item.disabled || false,"type":_vm.tabCur == item.value ? 'info': 'primary'},nativeOn:{"click":function($event){_vm.handleClick(item.value)}}},[_vm._v("\n        "+_vm._s(item.name)+"\n    ")])}))}
var button_group_staticRenderFns = []
var button_group_esExports = { render: button_group_render, staticRenderFns: button_group_staticRenderFns }
/* harmony default export */ var src_button_group = (button_group_esExports);
// CONCATENATED MODULE: ./src/plugin-api/packages/button/src/button-group.vue
function button_group_injectStyle (ssrContext) {
  __webpack_require__("1Al0")
}
var button_group_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var button_group___vue_template_functional__ = false
/* styles */
var button_group___vue_styles__ = button_group_injectStyle
/* scopeId */
var button_group___vue_scopeId__ = "data-v-bb5a5ea8"
/* moduleIdentifier (server only) */
var button_group___vue_module_identifier__ = null
var button_group_Component = button_group_normalizeComponent(
  button_group,
  src_button_group,
  button_group___vue_template_functional__,
  button_group___vue_styles__,
  button_group___vue_scopeId__,
  button_group___vue_module_identifier__
)

/* harmony default export */ var button_src_button_group = (button_group_Component.exports);

// CONCATENATED MODULE: ./src/plugin-api/packages/button-group/index.js
/**
 * Created by josh on 2017/8/11.
 */



/* istanbul ignore next */
button_src_button_group.install = function (Vue) {
  Vue.component(button_src_button_group.name, button_src_button_group);
};

/* harmony default export */ var packages_button_group = (button_src_button_group);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/plugin-api/packages/button/src/button-checkbox.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var button_checkbox = ({
    name: 'EButtonCheckbox',
    props: {
        type: {
            type: String,
            default: function _default() {
                return 'default';
            }
        },
        size: String,
        block: String,
        icon: {
            type: String,
            default: function _default() {
                return '';
            }
        },
        disabled: Boolean,
        name: String,
        value: {},
        label: {}
    },
    data: function data() {
        return {};
    },

    computed: {
        model: {
            get: function get() {
                return this.value;
            },
            set: function set(val) {
                this.$emit('input', val);
            }
        },
        isChecked: function isChecked() {
            if (Array.isArray(this.model)) {
                return this.model.indexOf(this.label) > -1;
            }
        }
    },
    methods: {
        handleChange: function handleChange(event) {
            this.$emit('change', event);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c0f77d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugin-api/packages/button/src/button-checkbox.vue
var button_checkbox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"btn",class:[
      _vm.type && !_vm.disabled ? 'btn-' + _vm.type : '',
      _vm.size ? 'btn-' + _vm.size : '',
      _vm.block ? 'btn-' + _vm.block : '',
      {
          'disabled btn-default': _vm.disabled,
          'btn-danger': _vm.isChecked
      }
    ]},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.model),expression:"model",modifiers:{"trim":true}}],staticClass:"checkbox-button",attrs:{"type":"checkbox","name":_vm.name,"disabled":_vm.disabled},domProps:{"value":_vm.label,"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,_vm.label)>-1:(_vm.model)},on:{"change":[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.label,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}},_vm.handleChange]}}),_vm._v(" "),(_vm.icon)?_c('i',{class:'fa fa-fw fa-lg fa-' + _vm.icon}):_vm._e(),_vm._v(" "),(_vm.$slots.disabled && _vm.disabled )?_c('span',[_vm._t("disabled")],2):_vm._e(),_vm._v(" "),(_vm.$slots.default && ( !_vm.$slots.disabled || !_vm.disabled ))?_c('span',[_vm._t("default")],2):_vm._e()])}
var button_checkbox_staticRenderFns = []
var button_checkbox_esExports = { render: button_checkbox_render, staticRenderFns: button_checkbox_staticRenderFns }
/* harmony default export */ var src_button_checkbox = (button_checkbox_esExports);
// CONCATENATED MODULE: ./src/plugin-api/packages/button/src/button-checkbox.vue
function button_checkbox_injectStyle (ssrContext) {
  __webpack_require__("0FkX")
}
var button_checkbox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var button_checkbox___vue_template_functional__ = false
/* styles */
var button_checkbox___vue_styles__ = button_checkbox_injectStyle
/* scopeId */
var button_checkbox___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var button_checkbox___vue_module_identifier__ = null
var button_checkbox_Component = button_checkbox_normalizeComponent(
  button_checkbox,
  src_button_checkbox,
  button_checkbox___vue_template_functional__,
  button_checkbox___vue_styles__,
  button_checkbox___vue_scopeId__,
  button_checkbox___vue_module_identifier__
)

/* harmony default export */ var button_src_button_checkbox = (button_checkbox_Component.exports);

// CONCATENATED MODULE: ./src/plugin-api/packages/button-checkbox/index.js
/**
 * Created by josh on 2017/8/11.
 */



/* istanbul ignore next */
button_src_button_checkbox.install = function (Vue) {
  Vue.component(button_src_button_checkbox.name, button_src_button_checkbox);
};

/* harmony default export */ var packages_button_checkbox = (button_src_button_checkbox);
// CONCATENATED MODULE: ./src/plugin-api/src/index.js
/**
 * Created by josh on 2017/8/11.
 */





var publicComponents = [packages_button, packages_button_group, packages_button_checkbox];
var install = function install(Vue) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    /* istanbul ignore if */
    if (install.installed) {
        return false;
    }
    install.installed = true;

    publicComponents.map(function (component) {
        Vue.component(component.name, component);
    });
};

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
};


// EXTERNAL MODULE: ./src/lib/resource.js
var resource = __webpack_require__("WcvB");

// EXTERNAL MODULE: ./node_modules/vue-jsonp/dist/vue-jsonp.umd.js
var vue_jsonp_umd = __webpack_require__("qJdI");
var vue_jsonp_umd_default = /*#__PURE__*/__webpack_require__.n(vue_jsonp_umd);

// CONCATENATED MODULE: ./src/lib/trackEvent.js
/* global someFunction _hmt:true */
/**
 * trackEvent 百度埋点
 * @param category   要监控的目标的类型名称，通常是同一组目标的名字，比如”视频”、”音乐”、”软件”、”游戏”等等。该项必选。
 * @param action     用户跟目标交互的行为，如”播放”、”暂停”、”下载”等等。该项必选。
 * @param opt_label  事件的一些额外信息，通常可以是歌曲的名称、软件的名称、链接的名称等等。该项可选。
 * @param opt_value  事件的一些数值信息，比如权重、时长、价格等等，在报表中可以看到其平均值等数据。该项可选
 */

// 判断定制 区分埋点
var source = '';
switch (lib_config["d" /* SOURCE */]) {
  case 'yonyou':
    source = 'yy-';
    break;
}
var trackEvent = function trackEvent(category, action, opt_label, opt_value) {
  _hmt.push(['_trackEvent', '' + source + category, action, opt_label, opt_value]);
};
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./src/resource-api/core/method.js
/**
 * 定义Method的类型
 * @param method:method
 */

/* harmony default export */ var core_method = ({
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE'
});
// CONCATENATED MODULE: ./src/resource-api/core/mode.js
/**
 * 定义ajax的请求类型
 * @param axios:axios (默认)
 *        Make XMLHttpRequests from the browser
 *        Make http requests from node.js
 *        Supports the Promise API
 * @param fetch:fetch 基于Promise
 * @param dd:钉钉   钉钉
 * @param weixin:  微信
 */

/* harmony default export */ var mode = ({
  axios: 'axios',
  fetch: 'fetch',
  dd: 'dd',
  weixin: 'weixin' // 不支持，后期添加
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./src/resource-api/core/util.js


/**
 * Created by josh on 17/08/22.
 */

/*
 *  克隆
 *   Object.create(obj);
 *   * obj 作为新创建对象的原型。
 *
 *   ** Object.create(null);   === var obj
 *   ** Object.create(Object.prototype);   === var obj = {};
 *   ** const A = {};   Object.getPrototypeOf( Object.create(A) ) === A  TRUE
 * */

/*
 * cloneObj 数组深度克隆
 * */
function deepCloneObj(obj) {
    var str = void 0;
    var newobj = obj.constructor === Array ? [] : {};
    // var arr = new Array() obj 是Array构造函数实例
    if ((typeof obj === 'undefined' ? 'undefined' : typeof_default()(obj)) !== 'object') {
        return;
    } else if (window.JSON) {
        str = stringify_default()(obj);
        newobj = JSON.parse(str);
    } else {
        for (var i in obj) {
            newobj[i] = typeof_default()(obj[i]) === 'object' ? deepCloneObj(obj[i]) : obj[i];
        }
    }
    return newobj;
}
/*
 * 单数组去重复 [a, b,c,d]
 * 空间换时间
 * */
function hashUnique(arr) {
    var result = [];
    var hash = {};
    for (var i = 0, elem; (elem = arr[i]) != null; i++) {
        if (!hash[elem]) {
            result.push(elem);
            hash[elem] = true;
        }
    }
    return result;
}

/*
 * 单数组去重复 [a, b,c,d]
 * 关键字 indexOf
 * */
function indexUnique(array) {
    var result = [array[0]]; // 结果数组
    // 从第二项开始遍历
    for (var i = 1; i < array.length; i++) {
        // 如果当前数组的第i项在当前数组中第一次出现的位置不是i，
        // 那么表示第i项是重复的，忽略掉。否则存入结果数组
        if (array.indexOf(array[i]) == i) {
            result.push(array[i]);
        };
    }
    return result;
}

/*
 * 单数组去重复 [a, b,c,d]
 * 将相同的值相邻，然后遍历去除重复值
 * */
function sortUnique(array) {
    array.sort();
    var result = [array[0]];
    for (var i = 1; i < array.length; i++) {
        if (array[i] !== result[result.length - 1]) {
            result.push(array[i]);
        }
    }
    return result;
}

/*
 * 单数组去重复 [a, b, a, d,a]
 * 思路：获取没重复的最右一值放入新数组
 * */
// eachUnique([1, 2, 3, 1, 11, 2, 3, 4, 5, 6, 3, 2, 3, 3, 1, 2, 3, 5, 3]);
function eachUnique(array) {
    var result = [];
    for (var i = 0, l = array.length; i < l; i++) {
        for (var j = i + 1; j < l; j++) {
            if (array[i] === array[j]) {
                j = ++i;
            }
        }
        result.push(array[i]);
    }
    return result;
}

/*
 * Object 深度合并
 * jquery.extend
 * */
function util_extend(obj, copyArray) {
    var src = void 0;
    var copyIsArray = void 0;
    var isArray = void 0;
    var copy = void 0;
    var name = void 0;
    var clone = void 0;
    var target = (typeof obj === 'undefined' ? 'undefined' : typeof_default()(obj)) == 'object' ? obj : {};

    if (copyArray != null) {
        for (name in copyArray) {
            src = target[name]; // ** 数组一
            copy = copyArray[name]; // ** 数组二

            // ** 防止无限循环
            if (target === copy) {
                continue;
            }

            var _isObject = copyIsArray = Array.isArray(copy); // **数组

            if (copy && ((typeof copy === 'undefined' ? 'undefined' : typeof_default()(copy)) == 'object' && !_isObject || copyIsArray)) {
                if (copyIsArray) {
                    copyIsArray = false;
                    isArray = Array.isArray(src);
                    clone = src && isArray ? src : [];
                } else {
                    clone = src && (typeof src === 'undefined' ? 'undefined' : typeof_default()(src)) == 'object' ? src : {};
                }
                // target[name] = extend(clone, copy, booble, callback);
                target[name] = util_extend(clone, copy);
            } else if (copy !== undefined) {
                target[name] = copy;
            }
        };
    };

    return target;
}

/**
 * Check whether the object has the property.
 * 方法会返回一个布尔值，其用来判断某个对象是否含有指定的属性
 */
var util_hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
    return util_hasOwnProperty.call(obj, key);
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 *
 */
function isObject(obj) {
    return obj !== null && (typeof obj === 'undefined' ? 'undefined' : typeof_default()(obj)) === 'object';
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 *  console.log(Object.prototype.toString.call(123)) //[object Number]
    console.log(Object.prototype.toString.call('123')) //[object String]
    console.log(Object.prototype.toString.call(undefined)) //[object Undefined]
    console.log(Object.prototype.toString.call(true)) //[object Boolean]
    console.log(Object.prototype.toString.call({})) //[object Object]
    console.log(Object.prototype.toString.call([])) //[object Array]
    console.log(Object.prototype.toString.call(function(){})) //[object Function]
 */
var util_toString = Object.prototype.toString;
var OBJECT_OBJECT = '[object Object]';
var OBJECT_NUMBER = '[object Number]';
var OBJECT_STRING = '[object String]';
var OBJECT_BOOLEAN = '[object Boolean]';
var OBJECT_ARRAY = '[object Array]';
var OBJECT_FUNCTION = '[object Function]';
function isPlainObject(obj) {
    return util_toString.call(obj) === OBJECT_OBJECT;
}
function isPlainNumber(obj) {
    return util_toString.call(obj) === OBJECT_NUMBER;
}
function isPlainString(obj) {
    return util_toString.call(obj) === OBJECT_STRING;
}
function isPlainBoolean(obj) {
    return util_toString.call(obj) === OBJECT_BOOLEAN;
}
function isPlainArray(obj) {
    return util_toString.call(obj) === OBJECT_ARRAY;
}
function isPlainFunction(obj) {
    return util_toString.call(obj) === OBJECT_FUNCTION;
}

/**
 *obj = object
 * false //不为空
 * true //为空
 */
function isEmptyObject(obj) {
    for (var name in obj) {
        return false;
    }
    return true;
}
// CONCATENATED MODULE: ./src/resource-api/core/ports.js



var ErrorValid = {
    errorValid: false,
    desc: []
};

var ports_validateProp = function validateProp(key, propOptions, propsData) {
    var prop = propOptions[key] || {};
    var absent = !hasOwn(propsData, key);
    var value = propsData[key];
    ErrorValid.errorValid = false;
    ErrorValid.desc = [];

    // 处理type = boolean
    if (isType(Boolean, prop.$type)) {
        if (absent && !hasOwn(prop, '$default')) {
            // 不含有且无default值
            value = false;
        } else if (!isType(String, prop.$type) && value === '') {
            value = true;
        }
    }

    // 处理 absent=true,检索是否有默认值
    if (value === undefined) {
        value = ports_getPropDefaultValue(prop, key);
    }

    if (false) {
        ports_assertProp(prop, key, value, absent);
    }

    if (ErrorValid.errorValid) {
        return ErrorValid;
    }

    return value;
};

/**
 * 默认值
 */
var ports_getPropDefaultValue = function getPropDefaultValue(prop, key) {
    if (!hasOwn(prop, '$default')) {
        return null;
    }
    var def = prop.$default;

    // const assertedValue  =  assertValue(prop, def)
    // if (!assertedValue.valid){
    //     process.env.NODE_ENV !== 'production' && console.error(`错误提示：字段("${key}:${prop.$default}")default值，与type类型不匹配`)
    //      ErrorValid.errorValid = true
    //      ErrorValid.desc.push(`错误提示：字段("${key}:${prop.$default}")default值，与type类型不匹配`)
    //      return null
    // }
    return typeof def === 'function' && prop.$type !== Function ? def() : def;
};

/**
 * prop
 * name = key
 * value = value
 *absent
 */
var ports_assertProp = function assertProp(prop, name, value, absent) {
    if (prop.$required && absent) {
        // required = true  无字段
        console.error('\u9519\u8BEF\u63D0\u793A\uFF1A\u5B57\u6BB5("' + name + '")\u662F\u5FC5\u586B\u5B57\u6BB5\uFF0C\u4E22\u5931\uFF0C\u8BF7\u68C0\u67E5');
        ErrorValid.errorValid = true;
        ErrorValid.desc.push('\u9519\u8BEF\u63D0\u793A\uFF1A\u5B57\u6BB5("' + name + '")\u662F\u5FC5\u586B\u5B57\u6BB5\uFF0C\u4E22\u5931\uFF0C\u8BF7\u68C0\u67E5');
        return;
    }

    if (value == null && !prop.$required) {
        return;
    }

    var assertedValue = assertValue(prop, value);

    if (!assertedValue.valid) {
        // 类型不匹配：字段 ${name}
        console.error('\u9519\u8BEF\u63D0\u793A\uFF1A\u5B57\u6BB5("' + name + ':' + value + '")\u539F\u7C7B\u578B' + assertedValue.expectedTypes + '\u4E0E\u73B0\u5728\u4E0D\u5339\u914D,\u8BF7\u68C0\u67E5');
        ErrorValid.errorValid = true;
        ErrorValid.desc.push('\u9519\u8BEF\u63D0\u793A\uFF1A\u5B57\u6BB5("' + name + ':' + value + '")\u539F\u7C7B\u578B' + assertedValue.expectedTypes + '\u4E0E\u73B0\u5728\u4E0D\u5339\u914D,\u8BF7\u68C0\u67E5');
        return;
    }

    var validator = prop.$validator;
    if (validator) {
        if (!isPlainFunction(validator) || !validator(value)) {
            console.error('\u9519\u8BEF\u63D0\u793A\uFF1A\u5B57\u6BB5("' + name + '")\u81EA\u5B9A\u4E49validator\u9519\u8BEF,\u8BF7\u68C0\u67E5');
            ErrorValid.errorValid = true;
            ErrorValid.desc.push('\u9519\u8BEF\u63D0\u793A\uFF1A\u5B57\u6BB5("' + name + '")\u81EA\u5B9A\u4E49validator\u9519\u8BEF,\u8BF7\u68C0\u67E5');
            return false;
        }
    }
};

var assertValue = function assertValue(prop, value) {
    var type = prop.$type;
    var valid = !type || type === true;
    var expectedTypes = [];
    if (type) {
        if (!Array.isArray(type)) {
            type = [type];
        }
        for (var i = 0; i < type.length && !valid; i++) {
            var assertedType = ports_assertType(value, type[i]);
            expectedTypes.push(assertedType.expectedType || ''); // [String,Number]
            valid = assertedType.valid;
        }
    }
    return {
        valid: valid,
        expectedTypes: expectedTypes
    };
};

/**
 * Number == number
 * 对比value 是否是对应的类型
 */
var ports_assertType = function assertType(value, type) {
    var valid = void 0;
    var expectedType = getType(type);
    if (expectedType === 'String') {
        valid = (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === (expectedType = 'string');
    } else if (expectedType === 'Number') {
        valid = (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === (expectedType = 'number');
    } else if (expectedType === 'Boolean') {
        valid = (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === (expectedType = 'boolean');
    } else if (expectedType === 'Function') {
        valid = (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === (expectedType = 'function');
    } else if (expectedType === 'Object') {
        valid = isPlainObject(value);
    } else if (expectedType === 'Array') {
        valid = Array.isArray(value);
    } else {
        valid = value instanceof type;
    }
    return {
        valid: valid,
        expectedType: expectedType
    };
};

/**
 * 对比类型
 *type
 *fn
 * return /true (Number) false（Number，number）
 */
var isType = function isType(type, fn) {
    if (!Array.isArray(fn)) {
        return getType(fn) === getType(type);
    }
    for (var i = 0, len = fn.length; i < len; i++) {
        if (getType(fn[i]) === getType(type)) {
            return true;
        }
    }
    return false;
};

/**
 * fn: Number String Object
 * return Number String Object / undefined
 */
var getType = function getType(fn) {
    var match = fn && fn.toString().match(/^\s*function (\w+)/);
    return match && match[1];
};
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("+6Bu");
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/resource-api/core/response.js





/**
 * HTTP请求
 * @param provide:传递的参数
 * @param Success：自定义回掉成功
 * @param Error：自动义回掉失败xxw
 * @param style: 代开发( 支持多种api请求  )
 * Config = {
              // 接口
              url: {
                  type: String,
                  required: true
              },
              // 方法
              method: {
                  type: String,
                  default: 'GET'
                  required: true
              },
              // 接口参数配置
              body: {
                  type: Object,
                  default: {}
              },
              // 请求模式 (fetch / 钉钉 ／ 微信 ／axios)
              mode: {
                  type: [axios, fetch, dd, weixin], // 排列顺序-满足条件
                  default: 'axios'
              },
              // 完成的回调
              done: {
                  type: Function
              }
          }
 **/


/* harmony default export */ var response = (function () {
  var provide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var Success = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var Error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  // 默认使用axios
  // dd = test 测试环境  dd = online 聚塔石环境
  var dd = false || false;
  var Mode = '';
  if (dd == 'online') {
    Mode = 'dd';
  } else if (dd == 'test') {
    Mode = 'fetch';
  } else {
    Mode = provide.mode || 'axios';
  }
  return defaultResult['_' + Mode](provide);
});

var defaultResult = {
  /**
   * 重置,服务端协议
   *  @param code: 错误码
   *  @param desc: 错误描述
   *  @param data: 正文
   */
  result: {},
  _dd: function _dd(provide) {},
  _axios: function _axios(provide) {
    var _this = this;

    var options = {
      mode: 'include'
    };

    var body = provide.body,
        method = provide.method,
        opt = objectWithoutProperties_default()(provide, ['body', 'method']);

    if (method == 'GET') {
      if (opt.url.indexOf('?') === -1) {
        opt.url = opt.url + '?t=' + Date.now();
      } else {
        opt.url = opt.url + '&t=' + Date.now();
      }
      options = extends_default()({ params: body, method: method }, opt);
    } else {
      options = extends_default()({ data: body, method: method }, opt);
    }
    return axios_default()(options).then(function (response) {
      var responseData = response.data;
      return _this.success(provide, responseData);
    }, function (response) {
      return _this.error(provide, response);
    });
  },
  _fetch: function _fetch(provide) {
    var _this2 = this;

    var options = {
      mode: 'cors', // cors(cors) / no-cors(opaque) / same-origin(basic)
      credentials: 'include', // include: 跨域下带cook  // same-origin: 同源, 表示同域请求才发送cookie.
      headers: {
        'Content-Type': 'application/json'
        // cache: 'default' // 缓存
        // 不支持jsonp请求  fetch-jsonp 解决
        // 没有 timeout 机制
        // 没有 progress 提示
        // 不支持原生的abort机制
      } };

    var url = provide.url,
        body = provide.body,
        method = provide.method,
        opt = objectWithoutProperties_default()(provide, ['url', 'body', 'method']);

    if (method == 'POST') {
      options = extends_default()({ body: stringify_default()(body), method: method }, opt, options);
    } else if (method == 'GET') {
      var str = keys_default()(body).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(body[key]);
      }).join('&');
      url = url + '?' + str;
      options = extends_default()({ method: method }, opt, options);
    }
    return fetch(url, options).then(function (response) {
      return response.json();
    }).then(function (responseData) {
      return _this2.success(provide, responseData);
    }, function (response) {
      return _this2.error(provide, response);
    });
  },

  // 成功回调
  success: function success(provide, responseData) {
    this.result = {};
    if (responseData.errCode === 0) {
      assign_default()(this.result, {
        data: responseData.data,
        msg: responseData.msg
      });
    } else {
      assign_default()(this.result, {
        // desc: '接口:' + provide.url + '  原因：' + responseData.msg,
        desc: responseData.msg,
        code: responseData.errCode
      });
    }
    return this.result;
  },

  // 失败回调
  error: function error(provide, _error) {
    this.result = {};
    assign_default()(this.result, {
      // desc: `获取数据模型失败，接口: ${provide.url} -  原因：${error} - 状态：${error.response.status} - 请刷新`
      desc: '\u83B7\u53D6\u6570\u636E\u6A21\u578B\u5931\u8D25'
    });
    return this.result;
  }
};
// CONCATENATED MODULE: ./src/resource-api/core/index.js







var core_Core = function Core(modules) {
    var ProvidesObject = modules;
    var ResponseObject = {};

    for (var moduleName in ProvidesObject) {
        ResponseObject[moduleName] = {};

        var _loop = function _loop(actionName) {
            var options = ProvidesObject[moduleName][actionName];
            ResponseObject[moduleName][actionName] = function (config) {
                var req = config || {};
                if (options['body']) {
                    req = core_extend(options['body'], config);
                }
                return response(assign_default()({}, options, { 'body': req }));
            };
        };

        for (var actionName in ProvidesObject[moduleName]) {
            _loop(actionName);
        }
    }

    return ResponseObject;
};

var core_extend = function extend(propOptions, propsData) {
    var value = void 0;
    var _propOptions = void 0;
    var isPropOptions = void 0;
    var target = {};

    if (propsData != null) {
        for (var key in propOptions) {
            value = propsData[key];
            _propOptions = propOptions[key] || {};
            isPropOptions = hasOwn(_propOptions, '$type') || hasOwn(_propOptions, '$default') || hasOwn(_propOptions, '$required') || hasOwn(_propOptions, '$validator');

            if (value && isPlainObject(value)) {
                if (!isPropOptions) {
                    target[key] = extend(_propOptions, value);
                }
            }

            if (!isEmptyObject(_propOptions) && !isPropOptions && !isPlainObject(value) && value !== undefined) {
                console.error('\u9519\u8BEF\u63D0\u793A\uFF1A\u5B57\u6BB5(' + key + ')\u4E0D\u6B63\u786E\uFF0C\u7C7B\u578B\u4E0D\u5339\u914D');
                return {};
            }

            var propValue = ports_validateProp(key, propOptions, propsData);

            if (propValue !== null && propValue.errorValid) {
                // console.log(propValue.desc[0])
                return {};
            }

            target[key] = propValue;
        }
    }

    return target;
};


// EXTERNAL MODULE: ./src/resource-api/config.js
var resource_api_config = __webpack_require__("S/Ce");

// CONCATENATED MODULE: ./src/resource-api/api/login.js
/**
 * login标签数据接口文档
 */



var api = resource_api_config["a" /* API */];

/* harmony default export */ var login = ({
  // 登陆
  login: {
    url: api + '/rest/v1/login',
    method: core_method.POST,
    body: {
      account: {
        $type: String,
        $required: true
      },
      pwd: {
        $type: [Number, String],
        $required: true
      },
      type: {
        $type: Number,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      crm: {
        $type: Object
      }
      // mode: Mode.fetch
    } },
  config: {
    url: api + '/rest/v1/login/config/63',
    method: core_method.GET,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 退出
  logout: {
    url: api + '/rest/v1/logout',
    method: core_method.POST,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 定制退出
  customelogout: {
    url: api + '/rest/v1/logout/third/yonyou',
    method: core_method.POST,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 验证码
  send: {
    url: api + '/rest/v1/code/send',
    method: core_method.GET,
    body: {
      // 手机号
      account: {
        $type: String
      },
      // type 类型
      type: {
        $type: Number
      },
      flowId: {},
      // 状态
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
      // mode: Mode.fetch
    } },
  // 银行四要素 信息对比 获取验证码
  bankInfo: {
    url: api + '/rest/v1/realname/person/bank/info',
    method: core_method.POST,
    body: {
      reRealName: {
        $type: Boolean,
        $default: false
      },
      name: {
        $type: String
      },
      // 银行卡
      cardno: {
        $type: String
      },
      // 身份证号
      idno: {
        $type: String
      },
      // 银行预留手机号
      mobile: {
        $type: String
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 银行四要素 获取验证码后提交
  bankCode: {
    url: api + '/rest/v1/realname/person/bank/code',
    method: core_method.POST,
    body: {
      reRealName: {
        $type: Boolean,
        $default: false
      },
      // 返回的 service id
      serviceId: {
        $type: String
      },
      // 验证码
      code: {
        $type: String
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 个人三要素 信息比较
  individuaInfo: {
    url: api + '/rest/v1/realname/person/telecom/info',
    method: core_method.POST,
    body: {
      reRealName: {
        $type: Boolean,
        $default: false
      },
      // name
      name: {
        $type: String
      },
      // 身份证
      idno: {
        $type: String
      },
      // 手机号
      mobile: {
        $type: String
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 个人web/个人h5 提交个人用户信息 获取实名url
  getpersonAuthUrl: {
    url: api + '/rest/v1/realname/person/getAuthUrl',
    method: core_method.POST,
    body: {
      reRealName: {
        $type: Boolean,
        $default: false
      },
      // name
      name: {
        $type: String
      },
      refresh: {
        $type: Number,
        $required: false
      },
      authId: {
        $type: String,
        $required: false
      },
      // 身份证
      idNo: {
        $type: String
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 个人web/个人h5/企业web 获取认证结果
  getAuthResult: {
    url: api + '/rest/v1/realname/getAuthResult',
    method: core_method.GET,
    body: {
      authId: {
        $type: String
      },
      userType: {
        $type: Number
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      queryFromAuthService: {
        $type: Boolean
      }
    }
  },
  // 个人 验证码
  individuaCode: {
    url: api + '/rest/v1/realname/person/telecom/code',
    method: core_method.POST,
    body: {
      reRealName: {
        $type: Boolean,
        $default: false
      },
      // 返回的 service id
      serviceId: {
        $type: String
      },
      // 验证码
      code: {
        $type: String
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 个人或企业注册
  regist: {
    url: api + '/rest/v1/account/regist',
    method: core_method.POST,
    body: {
      account: {
        $type: String
      },
      type: {
        $type: Number
      },
      pwd: {
        $type: String
      },
      code: {
        $type: String
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      crm: {
        $type: Object
      }
    }
  },
  // 企业信息校验
  groupInfoCheck: {
    url: api + '/rest/v1/realname/organ/check',
    method: core_method.POST,
    body: {
      reRealName: {
        $type: Boolean,
        $default: false
      },
      name: {
        $type: String
      },
      codeUSC: {
        $type: String
      },
      legalName: {
        $type: String
      },
      legalIdno: {
        $type: String
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 企业打款
  groupPay: {
    url: api + '/rest/v1/realname/organ/pay',
    method: core_method.POST,
    body: {
      bankAccount: {
        $type: String
      },
      cardno: {
        $type: String
      },
      bank: {
        $type: String
      },
      subbranch: {
        $type: String
      },
      provice: {
        $type: String
      },
      city: {
        $type: String
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 企业web 提交企业相关信息获取url
  getgroupAuthUrl: {
    url: api + '/rest/v1/realname/organ/getAuthUrl',
    method: core_method.POST,
    body: {
      reRealName: {
        $type: Boolean,
        $default: false
      },
      organName: {
        $type: String
      },
      licenseCode: {
        $type: String
      },
      legalName: {
        $type: String
      },
      legalIdNo: {
        $type: String
      },
      licenseType: {
        $type: Number,
        $default: 2
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 企业打款验证
  paycheck: {
    url: api + '/rest/v1/realname/paycheck',
    method: core_method.POST,
    body: {
      reRealName: {
        $type: Boolean,
        $default: false
      },
      cash: {
        $type: String
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 找回密码
  forget: {
    url: api + '/rest/v1/account/loginpwd/forget',
    method: core_method.POST,
    body: {
      account: {
        $type: String
      },
      pwd: {
        $type: String
      },
      code: {
        $type: String
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 设置签署密码
  setPwd: {
    url: api + '/rest/v1/account/signpwd/set',
    method: core_method.PUT,
    body: {
      pwd: {
        $type: String
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 用户状态 /rest/v1/account/status/get
  userStatusApi: {
    url: api + '/rest/v1/account/status/get',
    method: core_method.GET,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 第三方登录 轮询接口 /rest/v1/loginReturn/getState
  pollLoginState: {
    url: api + '/rest/v1/loginReturn/getState',
    method: core_method.GET,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      uniqueId: {
        $type: String
      }
    }
  },
  // 第三方登录 绑定账号 /rest/v1/login/bind
  accountBind: {
    url: api + '/rest/v1/login/bind',
    method: core_method.POST,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      // 绑定账户
      account: {
        $type: String
      },
      // 第三方 id
      thirdPartyUserId: {
        $type: String
      },
      //  第三方 key
      thirdPartyKey: {
        $type: String
      },
      // 绑定账号 验证类型 0-验证码 1-密码 默认-0
      type: {
        $type: Number
      },
      // 验证码
      code: {
        $type: String
      },
      // 密码
      pwd: {
        $type: String
      }
    }
  }
});
// CONCATENATED MODULE: ./src/resource-api/api/enroll.js
/**
 * enroll 标签数据接口文档
 */



var enroll_api = resource_api_config["a" /* API */];
// const api = 'http://115.238.39.106:28085/service';

/* harmony default export */ var api_enroll = ({
  // 企业人工实名上传图片
  uploadImg: {
    url: enroll_api + '/rest/v1/file/upload2oss',
    method: core_method.POST,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      file: {}
    }
  },
  // 企业 人工 信息
  manual: {
    url: enroll_api + '/rest/v1/realname/organ/manual',
    method: core_method.POST,
    body: {
      step: {
        $type: Number
      }, // 区分 企业信息，图片，银行信息
      organType: {
        $type: Number
      }, // 单位类型
      licenseType: {
        $type: Number
      }, // 营业执照类型
      name: {
        $type: String
      }, // 企业名称
      regCode: {
        $type: String
      }, // 工商注册号
      organCode: {
        $type: String
      }, // 组织结构代码
      legalArea: {
        $type: Number
      }, // 法人代表归属地
      legalName: {
        $type: String
      }, // 法人姓名
      legalIdNo: {
        $type: String
      }, // 法人身份证号码
      userType: {
        $type: Number
      }, // 注册类型
      legalPhoto: {
        $type: String
      },
      agentName: {
        $type: String
      }, // 代理人名称
      agentIdNo: {
        $type: String
      }, // 代理人身份证
      regPhoto: {
        $type: String
      }, // 工商注册号
      organPhoto: {
        $type: String
      }, // 组织机构代码
      legalPhotoPro: {
        $type: String
      }, // 法人身份证正面
      legalPhotoCon: {
        $type: String
      }, // 法人身份证反面
      agentPhotoPro: {
        $type: String
      }, // 代理人身份证正面
      agentPhotoCon: {
        $type: String
      }, // 代理人身份证反面
      agentPhoto: {
        $type: String
      }, // 代理人手持身份证照片
      proxyPhoto: {
        $type: String
      }, // 授权书照片
      bankAccount: {
        $type: String
      }, // 对公账户名
      bankNum: {
        $type: String
      }, // 企业对公银行账户
      bank: {
        $type: String
      }, // 企业银行账户开户行
      subbranch: {
        $type: String
      }, // 企业银行账户开户行名称
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 企业人工实名上传图片
  person: {
    url: enroll_api + '/rest/v1/realname/person/manual',
    method: core_method.POST,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      personArea: {
        $type: Number
      }, // 个人归属地
      name: {
        $type: String
      }, // 姓名
      idNo: {
        $type: String
      }, // 身份证号
      idPhotoPro: {
        $type: String
      }, // 身份证正面URL
      idPhotoCon: {
        $type: String
      }, // 身份证背面URL
      photo: {
        $type: String
      }, // 个人近照URL
      bank: {
        $type: String
      }, // 企业银行账号开户行名称
      subbranch: {
        $type: String
      }, // 企业支行
      bankNum: {
        $type: String // 企业对公银行账号
      } }
  }
});
// CONCATENATED MODULE: ./src/resource-api/api/contact.js
/**
 * 联系人管理标签数据接口文档
 */



var contact_api = resource_api_config["a" /* API */];

/* harmony default export */ var contact = ({
  // 分页获取联系人列表
  getContactList: {
    url: contact_api + '/rest/v1/contact/list',
    method: core_method.GET,
    body: {
      page: {
        $type: Number,
        $required: true
      },
      pageSize: {
        $type: Number,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      condition: {
        $type: [String, Number]
      }
    }
  },
  // 添加联系人
  addContacts: {
    url: contact_api + '/rest/v1/contact/add',
    method: core_method.POST,
    body: {
      account: {
        $type: String,
        $required: true
      },
      nickname: {
        $type: String,
        $required: true
      },
      comments: {
        $type: String
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 更新联系人
  updateContacts: {
    url: contact_api + '/rest/v1/contact/update',
    method: core_method.PUT,
    body: {
      contactId: {
        $type: String,
        $required: true
      },
      account: {
        $type: String,
        $required: true
      },
      nickname: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      comments: {
        $type: String
      }
    }
  },
  // 删除联系人
  deleteContacts: {
    url: contact_api + '/rest/v1/contact/delete',
    method: core_method.DELETE,
    body: {
      contactId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  }
});
// CONCATENATED MODULE: ./src/resource-api/api/home.js
/**
 * login标签数据接口文档
 */



var home_api = resource_api_config["a" /* API */];
var local = resource_api_config["b" /* LOCAL */];

/* harmony default export */ var home = ({
  // 获取用户信息
  info: {
    // url: `${api}/rest/v1/account/info/4095`,
    url: home_api + '/rest/v1/account/info/base',
    method: core_method.GET,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 催签文档
  remindMyDoc: {
    url: home_api + '/rest/v1/signflow/remind',
    method: core_method.POST,
    body: {
      flowId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 退回文档
  rejectMyDoc: {
    url: home_api + '/rest/v1/signflow/reject',
    method: core_method.POST,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      reason: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 撤回文档
  revokeMyDoc: {
    url: home_api + '/rest/v1/signflow/revoke',
    method: core_method.POST,
    body: {
      flowId: {
        $type: String,
        $required: true
      },
      reason: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 更新通知
  update: {
    url: home_api + '/rest/v1/alert/set/update',
    method: core_method.PUT,
    body: {
      sms: {
        $type: Boolean
      },
      email: {
        $type: Boolean
      },
      expire: {
        $type: Boolean
      },
      contractExpire: {
        $type: Boolean
      },
      expireTime: {
        $type: Number
      },
      contractExpireTime: {
        $type: Number
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 设置签署密码
  signpwd: {
    url: home_api + '/rest/v1/account/signpwd/set',
    method: core_method.PUT,
    body: {
      pwd: {
        $type: String
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 设置登录密码
  loginpwd: {
    url: home_api + '/rest/v1/account/loginpwd/set',
    method: core_method.PUT,
    body: {
      pwd: {
        $type: String
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 验证码校验
  codeValidate: {
    url: home_api + '/rest/v1/code/validate',
    method: core_method.POST,
    body: {
      code: {
        $type: String
      },
      type: {
        $type: Number
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 验证码校验
  account: {
    url: home_api + '/rest/v1/account/account/set',
    method: core_method.PUT,
    body: {
      code: {
        $type: String
      },
      account: {
        $type: String
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 用户实名信息
  accountInfo: {
    url: home_api + '/rest/v1/account/info/19',
    method: core_method.GET,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 用户实名状态
  status: {
    url: home_api + '/rest/v1/account/info/2',
    method: core_method.GET,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 用户头像信息
  portrait: {
    url: home_api + '/rest/v1/account/info/97',
    method: core_method.GET,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 用户实名 缓存数据 /rest/v1/realname/organ/getCacheInfo?source=esign
  getCacheInfo: {
    url: home_api + '/rest/v1/realname/organ/getCacheInfo',
    method: core_method.GET,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 提交重新认 证验证码  /rest/v1/login/confirm
  confirm: {
    url: home_api + '/rest/v1/login/confirm',
    method: core_method.POST,
    body: {
      source: {
        $default: resource_api_config["c" /* SOURCE */]
      },
      type: {
        $type: Number
      },
      pwd: {
        $type: String
      }
    }
  },
  // 获取银行信息
  getbankList: {
    url: home_api + '/rest/bank/bankList',
    method: core_method.GET,
    body: {
      bankName: {
        $type: String
      }
    }
  },
  // 获取支行信息
  getsubBankList: {
    url: home_api + '/rest/bank/subBankList',
    method: core_method.GET,
    body: {
      bankName: {
        $type: String
      },
      provinceCode: {
        $type: String
      },
      cityCode: {
        $type: String
      },
      subBankName: {
        $type: String
      }
    }
  },
  // 获取首页实例 印章
  getExampleSeal: {
    url: home_api + '/rest/v1/account/getExampleSeal',
    method: core_method.GET,
    body: {
      source: {
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 关闭用户指导
  guideClose: {
    url: home_api + '/rest/preferences',
    method: core_method.PUT,
    body: {
      accountUid: {
        $type: String
      },
      name: {
        $type: String
      },
      value: {
        $type: [String, Boolean]
      },
      source: {
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  }
});
// CONCATENATED MODULE: ./src/resource-api/api/sign.js
/**
 * 签署标签数据接口文档
 */



var sign_api = resource_api_config["a" /* API */];

/* harmony default export */ var sign = ({
  // 获取签署流程信息
  operations: {
    url: sign_api + '/rest/v1/signflow/participantInfos',
    method: core_method.GET,
    body: {
      flowId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
      // mode: Mode.fetch
    } },

  // 发起签署
  initiate: {
    url: sign_api + '/rest/v1/signflow/initiate',
    method: core_method.POST,
    body: {
      flowId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      docPosList: {
        $type: Array
      }
    }
  },

  // 保存流程信息
  update: {
    url: sign_api + '/rest/v1/signflow/update',
    method: core_method.PUT,
    body: {
      flowId: {
        $type: [String, Number],
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      userFolderId: {
        $type: String,
        $default: true
      },
      docName: {
        $type: String,
        $required: true
      },
      flowType: {
        $type: [Number, String],
        $required: true
      },
      isRealSign: {
        $type: Number,
        $required: true
      },
      signDeadline: {},
      contractStartline: {},
      contractDeadline: {},
      description: {},
      payMethod: {
        $type: [Number, String],
        $required: true
      },
      receivers: {
        $type: Array,
        $required: true
      }
    }
  },

  // 签署流程详情
  detail: {
    url: sign_api + '/rest/v1/signflow/detail',
    method: core_method.GET,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },

  // 删除签署流程文档
  deleteDoc: {
    url: sign_api + '/rest/v1/signflow/deleteDoc',
    method: core_method.DELETE,
    body: {
      flowDocId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },

  // 批量上传文件 md5
  // "key":"a","filename":"b","filetype":"c"
  checkmd5: {
    url: sign_api + '/rest/v1/file/upload',
    method: core_method.POST,
    body: {
      flowId: {
        $type: String
      },
      docName: {
        $type: String,
        $required: true
      },
      flowType: {
        $required: true
      },
      md5List: {
        $type: Array,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },

  // 批量更新文件名称
  rename: {
    url: sign_api + '/rest/v1/file/rename',
    method: core_method.PUT,
    body: {
      items: {
        $type: Array,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },

  // 签署
  sign: {
    url: sign_api + '/rest/v1/signflow/sign',
    method: core_method.POST,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      isAutoComplete: {
        $type: [Number, String],
        $required: true
      },
      code: {
        $required: true
      },
      validateType: {
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      docSignInfoList: {
        $type: Array,
        $required: true
      }
    }
  },

  // 更新用户新手状态 http://127.0.0.1:8084/service/rest/preferences
  preferences: {
    url: sign_api + '/rest/preferences',
    method: core_method.PUT,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      name: {
        $type: String,
        $default: 'need_show_guide_page'
      },
      value: {
        $type: String
      },
      accountUid: {
        $type: String
      }
    }
  }
});
// CONCATENATED MODULE: ./src/resource-api/api/myDoc.js
/**
 * 联系人管理标签数据接口文档
 */



var myDoc_api = resource_api_config["a" /* API */];

/* harmony default export */ var myDoc = ({
  moveTo: {
    url: myDoc_api + '/rest/v1/signflow/moveTo',
    method: core_method.POST,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      userFolderId: {
        $type: String
      },
      participantId: {
        $type: String
      }
    }
  },
  // 重命名文件夹 /rest/v1/userfolder/rename
  rename: {
    url: myDoc_api + '/rest/v1/userfolder/rename',
    method: core_method.POST,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      userFolderId: {
        $type: String
      },
      userFolderName: {
        $type: String
      }
    }
  },
  // 获取文件夹列表 /rest/v1/userfolder/query
  getFileList: {
    url: myDoc_api + '/rest/v1/userfolder/query',
    method: core_method.GET,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      accountUid: {
        $type: String,
        $required: false
      },
      needCount: {
        $type: Boolean,
        $default: true
      }
    }
  },

  // 添加 文件夹 /rest/v1/userfolder/add
  addFile: {
    url: myDoc_api + '/rest/v1/userfolder/add',
    method: core_method.POST,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      userFolderName: {
        $type: String
      }
    }
  },

  //  删除文件夹
  delFile: {
    url: myDoc_api + '/rest/v1/userfolder/delete',
    method: core_method.POST,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      userFolderId: {
        $type: String
      }
    }
  },

  // 获取文档数量
  count: {
    url: myDoc_api + '/rest/v1/signflow/count',
    method: core_method.GET,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      accountUid: {
        $type: String
      }
    }
  },

  // 分页获取文档列表
  getMyDocList: {
    url: myDoc_api + '/rest/v1/signflow/list',
    method: core_method.GET,
    body: {
      page: {
        $type: Number,
        $required: true
      },
      pageSize: {
        $type: Number,
        $required: true
      },
      status: {
        $type: Number,
        $required: false
      },
      docName: {
        $type: String,
        $required: false
      },
      senderKeyInfo: {
        $type: String,
        $required: false
      },
      receiverKeyInfo: {
        $type: String,
        $required: false
      },
      needTotalCount: {
        $type: Boolean
      },
      userFolderId: {
        $type: String
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      showReceivers: {
        $type: Number
      }
    }
  },

  // 下载文档
  downloadMyDoc: {
    url: myDoc_api + '/rest/v1/signflow/download',
    method: core_method.GET,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },

  // 删除文档
  deleteMyDoc: {
    url: myDoc_api + '/rest/v1/signflow/delete',
    method: core_method.DELETE,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },

  // 移出文档
  moveOutMyDoc: {
    url: myDoc_api + '/rest/v1/signflow/moveOut',
    method: core_method.POST,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      userFolderId: {
        $type: String
      },
      participantId: {
        $type: String
      }
    }
  },

  // 退回文档
  rejectMyDoc: {
    url: myDoc_api + '/rest/v1/signflow/reject',
    method: core_method.POST,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      reason: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },

  // 撤回文档
  revokeMyDoc: {
    url: myDoc_api + '/rest/v1/signflow/revoke',
    method: core_method.POST,
    body: {
      flowId: {
        $type: String,
        $required: true
      },
      reason: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },

  // 催签文档
  remindMyDoc: {
    url: myDoc_api + '/rest/v1/signflow/remind',
    method: core_method.POST,
    body: {
      flowId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },

  // 获取他人账户信息
  getOtherInfo: {
    url: myDoc_api + '/rest/v1/account/info/other',
    method: core_method.GET,
    body: {
      account: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },

  // 转签
  transferMyDoc: {
    url: myDoc_api + '/rest/v1/signflow/transfer',
    method: core_method.POST,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      transferAccountUid: {
        $type: String,
        $required: false
      },
      transferAccount: {
        $type: String,
        $required: true
      },
      transferName: {
        $type: String,
        $required: false
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },

  // 文档详情
  detailMyDoc: {
    url: myDoc_api + '/rest/v1/signflow/detail',
    method: core_method.GET,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },

  // 获取文档合同内容
  getOsskeyImage: {
    url: myDoc_api + '/rest/v1/file/image',
    method: core_method.GET,
    body: {
      osskey: {
        $type: String,
        $required: false
      },
      pageNum: {
        $type: String,
        $required: false
      },
      imageSize: {
        $type: Number,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },

  // 查询剩余签署次数
  getBillingInfo: {
    url: myDoc_api + '/rest/v1/account/billingInfo',
    method: core_method.GET,
    body: {
      accountInfo: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  }
});
// CONCATENATED MODULE: ./src/resource-api/api/seal.js
/**
 * 印章管理 接口
 */



var seal_api = resource_api_config["a" /* API */];

/* harmony default export */ var seal = ({
  // 印章列表
  sealList: {
    url: seal_api + '/rest/v1/seal/list',
    // url: `http://127.0.0.1:3000/api/rest/v1/seal/list`,
    method: core_method.GET,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      status: {
        $type: Number
      },
      page: {
        $type: Number,
        $default: 1
      },
      pageSize: {
        $type: Number,
        $default: 30
      }
    }
  },
  // 被授权的印章列表
  grantList: {
    url: seal_api + '/rest/v1/seal/grant/list',
    // url: `http://127.0.0.1:3000/api/rest/v1/seal/grant/list`,
    method: core_method.GET,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      page: {
        $type: Number,
        $default: 1
      },
      needCert: {
        $type: Boolean,
        $default: false
      },
      pageSize: {
        $type: Number,
        $default: 30
      }
    }
  },
  // 获取他人账户信息
  otherInfo: {
    url: seal_api + '/rest/v1/account/info/other',
    // url: `http://127.0.0.1:3000/api/rest/v1/seal/grant/list`,
    method: core_method.GET,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      account: {
        $type: String
      }
    }
  },
  // 添加 模板印章 法人印章
  personTempalte: {
    url: seal_api + '/rest/v1/seal/person/template/add',
    method: core_method.POST,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      templateType: {
        $type: String
      },
      color: {
        $type: String
      },
      name: {
        $type: String
      },
      personName: {
        $type: String
      },
      isSave: {
        $type: Boolean
      },
      uses: {
        $type: Array
      },
      audits: {
        $type: Array
      }
    }
  },
  // 添加企业模板印章
  organTemplate: {
    url: seal_api + '/rest/v1/seal/organ/template/add',
    method: core_method.POST,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      templateType: {
        $type: String
      },
      central: {
        $type: String
      },
      color: {
        $type: String
      },
      name: {
        $type: String
      },
      organName: {
        $type: String
      },
      hText: {
        $type: String
      },
      qText: {
        $type: String
      },
      isSave: {
        $type: Boolean
      },
      uses: {
        $type: Array
      },
      audits: {
        $type: Array
      }
    }
  },
  // 上传手绘数据 /rest/v1/seal/hand/add
  sealHand: {
    url: seal_api + '/rest/v1/seal/hand/add',
    method: core_method.POST,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      // 印章名称
      name: {
        $type: String
      },
      // 印章base64
      base64Data: {
        $type: String
      },
      // 使用人
      uses: {
        $type: Array
      },
      // 审计人
      audits: {
        $type: Array
      }
    }
  },
  // 处理图片印章 印章还原度
  compressImage: {
    url: seal_api + '/rest/v1/seal/image/compress',
    method: core_method.POST,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      sealBase64: {
        $type: String
      },
      color: {
        $type: String
      },
      cvalue: {
        $type: Number
      }
    }
  },
  // 添加图片印章
  addImgSeal: {
    url: seal_api + '/rest/v1/seal/image/add',
    method: core_method.POST,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      needCompress: {
        $type: Boolean,
        $default: true
      },
      name: {
        $type: String
      },
      imageBase64: {
        $type: String
      },
      color: {
        $type: String
      },
      cvalue: {
        $type: Number
      },
      width: {
        $type: Number
      },
      height: {
        $type: Number
      },
      uses: {
        $type: Array
      },
      audits: {
        $type: Array
      },
      accountUid: {
        $type: String
      },
      sealType: {
        $type: String
      }
    }
  },
  // 获取手绘授权 CODE
  sealCode: {
    url: seal_api + '/rest/v1/seal/hand/code',
    // url: 'http://115.238.39.106:28085/service/rest/v1/seal/hand/code',
    method: core_method.GET,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 获取手绘数据
  handData: {
    url: seal_api + '/rest/v1/seal/hand/data',
    // url: 'http://115.238.39.106:28085/service/rest/v1/seal/hand/data',
    method: core_method.GET,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      code: {
        $type: String
      }
    }
  },
  // 编辑印章 /rest/v1/seal/update
  sealUpdateApi: {
    url: seal_api + '/rest/v1/seal/update',
    method: core_method.PUT,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      name: {
        $type: String
      },
      sealId: {
        $type: String
      },
      base64Data: {
        $type: String
      },
      uses: {
        $type: Array
      },
      audits: {
        $type: Array
      },
      delUses: {
        $type: Array
      },
      delAudits: {
        $type: Array
      }
    }
  },
  // 删除印章 /rest/v1/seal/delete
  delSeal: {
    url: seal_api + '/rest/v1/seal/delete',
    method: core_method.DELETE,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      sealId: {
        $type: String
      }
    }
  },
  // 设置默认印章
  defSeal: {
    url: seal_api + '/rest/v1/seal/default',
    method: core_method.PUT,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      sealId: {
        $type: String
      }
    }
  },
  // 印章详情 /rest/v1/seal/detail
  detailSwalApi: {
    url: seal_api + '/rest/v1/seal/detail',
    method: core_method.GET,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      sealId: {
        $type: String
      }
    }
  }
});
// CONCATENATED MODULE: ./src/resource-api/api/bindUkey.js
/**
 *  绑定Ukey接口文档
 */



var bindUkey_api = resource_api_config["a" /* API */];

/* harmony default export */ var bindUkey = ({
  // 绑定接口
  bindUkey: {
    url: bindUkey_api + '/rest/v1/cert/ukey/bind',
    method: core_method.POST,
    body: {
      certBase64: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 获取证书列表
  getCertList: {
    url: bindUkey_api + '/rest/v1/accountcert/list',
    method: core_method.GET,
    body: {
      type: {
        $type: Number,
        $required: true
      },
      page: {
        $type: Number,
        $required: true
      },
      pageSize: {
        $type: Number,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 解除绑定ukey
  UnbindUkey: {
    url: bindUkey_api + '/rest/v1/cert/ukey/unbind',
    method: core_method.DELETE,
    body: {
      certId: {
        $type: Number,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 查看未来一个月内失效的证书
  getExpireCertList: {
    url: bindUkey_api + '/rest/v1/accountcert/expire',
    method: core_method.GET,
    body: {
      expireDays: {
        $type: Number,
        $required: true
      },
      page: {
        $type: Number,
        $required: true
      },
      pageSize: {
        $type: Number,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  //  Ukey签署hash值获取
  getHash: {
    url: bindUkey_api + '/rest/v1/ukeySign/hash',
    method: core_method.POST,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      flowDocId: {
        $type: String,
        $required: true
      },
      pos: {
        $type: Object,
        $required: true
      },
      certBase64: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // Ukey签署签名值及hash值合成
  mergeHash: {
    url: bindUkey_api + '/rest/v1/ukeySign/merge',
    method: core_method.POST,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      flowDocId: {
        $type: String,
        $required: true
      },
      signature: {
        $type: String,
        $required: true
      },
      isCompleted: {
        $type: Number,
        $required: false
      },
      certSN: {
        $type: String,
        $required: false
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 更改签署状态
  changeStatus: {
    url: bindUkey_api + '/rest/v1/ukeySign/done',
    method: core_method.PUT,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 通过证书序列号判断是否绑定
  haveBindUkey: {
    url: bindUkey_api + '/rest/v1/accountcert/haveBindUkey',
    method: core_method.GET,
    body: {
      sn: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 批量签署-获取hash
  getBatchHash: {
    url: bindUkey_api + '/rest/v1/ukeySign/batch/hash',
    method: core_method.POST,
    body: {
      participantIdList: {
        $type: Array,
        $required: true
      },
      pos: {
        $type: Object,
        $required: true
      },
      certBase64: {
        $type: String,
        $required: true
      },
      positioned: {
        $type: Number,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 批量签署-签名值合成
  mergeBatchHash: {
    url: bindUkey_api + '/rest/v1/ukeySign/batch/merge',
    method: core_method.POST,
    body: {
      participantIdList: {
        $type: Array,
        $required: true
      },
      signatureList: {
        $type: Array,
        $required: true
      },
      isCompleted: {
        $type: Number,
        $required: false
      },
      certSN: {
        $type: String,
        $required: false
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 批量签署-完善签署
  batchDone: {
    url: bindUkey_api + '/rest/v1/ukeySign/batch/done',
    method: core_method.PUT,
    body: {
      participantIdList: {
        $type: Array,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  }
});
// CONCATENATED MODULE: ./src/resource-api/api/myTemp.js
/**
 * my-templa 我的模板
 */



var myTemp_api = resource_api_config["a" /* API */];

/* harmony default export */ var myTemp = ({
  // 我的模板 list
  templateList: {
    url: myTemp_api + '/rest/v1/template/query',
    method: core_method.GET,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      templateName: {
        $type: String
      },
      page: {
        $type: Number,
        $required: true
      },
      pageSize: {
        $type: Number,
        $required: true
      }
    }
  },
  // 获取文档下载url
  downloadTemplate: {
    url: myTemp_api + 'rest/v1/template/download',
    method: core_method.GET,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      templateId: {
        $type: String,
        $required: true
      }
    }
  },
  // 删除模板
  deleteTemplate: {
    url: myTemp_api + '/rest/v1/template/delete',
    method: core_method.DELETE,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      templateId: {
        $type: String,
        $required: true
      }
    }
  }
});
// CONCATENATED MODULE: ./src/resource-api/api/template.js
/**
 * 合同模板接口文档
 */



var template_api = resource_api_config["a" /* API */];
var template_local = resource_api_config["b" /* LOCAL */];

/* harmony default export */ var template = ({
  // 获取文档信息
  getDoc: {
    url: template_api + '/rest/v1/template/findById',
    method: core_method.GET,
    body: {
      templateId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 更新模板
  updateDoc: {
    url: template_api + '/rest/v1/template/update',
    method: core_method.POST,
    body: {
      templateId: {
        $type: String,
        $required: true
      },
      templateName: {
        $type: String,
        $required: true
      },
      font: {
        $type: String,
        $required: true
      },
      fontSize: {
        $type: Number,
        $required: true
      },
      fieldDataList: {
        $type: Array,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 更新模板
  geneDoc: {
    url: template_api + '/rest/v1/template/generatePdf',
    method: core_method.POST,
    body: {
      templateId: {
        $type: String,
        $required: true
      },
      fieldDataList: {
        $type: Array,
        $required: true
      },
      docName: {
        $type: String,
        $required: false
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 获取填写内容
  getInputData: {
    url: template_api + '/rest/v1/template/getInputData',
    method: core_method.GET,
    body: {
      templateId: {
        $type: String,
        $required: true
      },
      inputDataId: {
        $type: String,
        $required: false
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 发起签署上传
  uploadTemp: {
    url: template_api + '/rest/v1/file/upload/osskey',
    method: core_method.POST,
    body: {
      keyList: {
        $type: Array,
        $required: true
      },
      docName: {
        $type: String,
        $required: true
      },
      flowType: {
        $type: Number,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  }
});
// CONCATENATED MODULE: ./src/resource-api/api/realName.js
/**
 * 实名流程接口
 */



var realName_api = resource_api_config["a" /* API */];

/* harmony default export */ var realName = ({
  // 多次打款
  payAgain: {
    url: realName_api + '/rest/v1/realname/organ/payAgain',
    method: core_method.POST,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 多次打款
  updateStatus: {
    url: realName_api + '/rest/v1/realname/organ/update2UnRealname',
    method: core_method.POST,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  }
});
// CONCATENATED MODULE: ./src/resource-api/api/user.js
/**
 * user 用户中心api
 */



var user_api = resource_api_config["a" /* API */];

/* harmony default export */ var user = ({
  // 注销账户 /rest/v1/account/cance
  cancelAccount: {
    url: user_api + '/rest/v1/account/cancel',
    method: core_method.POST,
    body: {
      // 建议
      suggestion: {
        $type: String
      },
      // 注销原因
      reason: {
        $type: [String, Array]
      },
      // 是否在web注销 0-web 1-h5 default web
      type: {
        $type: [String, Number],
        $default: 0
      },
      // 账号Uid
      accountUid: {
        $type: String
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 同意协议 /rest/v1/account/protocol/accept
  acceptProtocol: {
    url: user_api + '/rest/v1/account/protocol/accept',
    method: core_method.POST,
    body: {
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      },
      // 印章授权: GRANT_SEAL 注销账号: CANCEL_ACCOUNT
      protocolType: {
        $type: String
      },
      accountUid: {
        $type: String
      }
    }
  }
});
// CONCATENATED MODULE: ./src/resource-api/api/batch.js
/**
 * 联系人管理标签数据接口文档
 */



var batch_api = resource_api_config["a" /* API */];

/* harmony default export */ var batch = ({
  // 获取合同
  getDocInfos: {
    url: batch_api + '/rest/v1/signflow/batch/docInfos',
    method: core_method.POST,
    body: {
      participantList: {
        $type: [Array]
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 获取印章详情列表
  getSealList: {
    url: batch_api + '/rest/v1/seal/list/detail',
    method: core_method.GET,
    body: {
      page: {
        $type: Number,
        $required: true
      },
      pageSize: {
        $type: Number,
        $required: true
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 获取授权印章
  getGrantSealList: {
    url: batch_api + '/rest/v1/seal/grant/list',
    method: core_method.GET,
    body: {
      page: {
        $type: Number,
        $required: true
      },
      pageSize: {
        $type: Number,
        $required: true
      },
      needCert: {
        $type: Boolean
      },
      accountUid: {
        $type: String
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 云证书批量签署
  cloudSign: {
    url: batch_api + '/rest/v1/cloudSign/batch',
    method: core_method.POST,
    body: {
      participantIdList: {
        $type: [String, Array]
      },
      posArray: {
        $type: Array
      },
      positioned: {
        $type: Number
      },
      validateType: {
        $type: Number
      },
      code: {
        $type: String
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 发送验证码
  sendCode: {
    url: batch_api + '/rest/v1/code/send',
    method: core_method.POST,
    body: {
      account: {
        $type: String
      },
      type: {
        $type: Number
      },
      flowIdList: {
        $type: [String, Array]
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 校验验证码
  validateCode: {
    url: batch_api + '/rest/v1/code/validate',
    method: core_method.POST,
    body: {
      account: {
        $type: String
      },
      code: {
        $type: String
      },
      type: {
        $type: Number
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // 查看ukey列表
  getUkeyList: {
    url: batch_api + '/rest/v1/accountcert/list',
    method: core_method.GET,
    body: {
      page: {
        $type: Number
      },
      pageSize: {
        $type: Number
      },
      type: {
        $type: Number
      },
      accountId: {
        $type: Number
      },
      accountUid: {
        $type: String
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  },
  // ukey签署合成
  batchMerge: {
    url: batch_api + '/rest/v1/ukeySign/batch/merge',
    method: core_method.POST,
    body: {
      participantIdList: {
        $type: [String, Array]
      },
      signatureList: {
        $type: Array
      },
      certId: {
        $type: String
      },
      certSN: {
        $type: String
      },
      isCompleted: {
        $type: Number
      },
      accountUid: {
        $type: String
      },
      source: {
        $type: String,
        $default: resource_api_config["c" /* SOURCE */]
      }
    }
  }
});
// CONCATENATED MODULE: ./src/resource-api/index.js















// 接口配置封装
var resourceApi = core_Core({
  contact: contact,
  login: login,
  sign: sign,
  enroll: api_enroll,
  home: home,
  myDoc: myDoc,
  seal: seal,
  bindUkey: bindUkey,
  template: template,
  myTemp: myTemp,
  realName: realName,
  user: user,
  batch: batch
});

/* harmony default export */ var resource_api = (resourceApi);

// Config = {
//     // 接口
//     url: {
//         type: String,
//         required: true
//     },
//     // 方法
//     method: {
//         type: String,
//         default: 'GET'
//     },
//     // 接口参数配置
//     body: {
//         type: Object,
//         default: {}
//     },
//     // 请求模式 (fetch / 钉钉 ／ 微信 ／axios) 数组支持先后顺序 [钉钉,fetch]
//     mode: {
//         type: Array,
//         default: [fetch]
//     },
//     // 完成的回调
//     done: {
//         type: Function
//     }
// }


// post 例子
//  ResourceApi.login.add({
//     username: 'josh',
//     password: 1233
// }).then(res => {
//     console.log(res);
// });

// get 列子
// ResourceApi.login.get().then(res => {
//     console.log(res);
// });
// CONCATENATED MODULE: ./src/lib/eleValidate.js
// 手机
// const RegexPhone = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
var RegexPhone = /^(0|86|17951)?1[0-9]{10}$/;
// 邮箱
var RegEmail = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
// 密码 必须是字母数字组合
var RegPass = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
// 验证码 4位
var RegCode = /^\d+$/;
// 身份证
var RegIdNum = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[X])$)$/;
// 银行卡 16或
var RegBankNum = /^\d+$/;
var RegBankNum3 = /^\d{19}$/;
// 银行卡 16位 带空格
var RegBankNum2 = /^\d{4}(?:\s\d{4}){3}$/;
// 匹配姓名 中文 2-4个字符
// const RegName = /^([\u4e00-\u9fa5\ ]{2,4})$/;
var RegName = /^[\u4e00-\u9fa5]+$/;
// 必须数字
var RegIsNum = /^\d+$/;
// 正整数
var RegPINum = /^[1-9]\d*$/;
// 确认密码
var chekPass = '';

// 不能为空
var VaName = function VaName(rule, value, callback) {
  var key = '姓名';
  switch (rule.field) {
    case 'name':
      key = '姓名';
      break;
    case 'id':
      key = '身份证号';
      break;
    case 'groupName':
      key = '企业名称';
      break;
    case 'groupPapersNum':
      key = '企业证件号码';
      break;
    case 'legalName':
      key = '法人姓名';
      break;
    case 'bankAccount':
      key = '对公账户户名';
      break;
    case 'cardno':
      key = '企业对公银行账号';
      break;
    case 'bank':
      key = '企业银行开户行名称';
      break;
    case 'subbranch':
      key = '企业银行账号开户支行全称';
      break;
    case 'selectedOptions':
      key = '营业地址不能为空';
      break;
  }
  if (!value) {
    callback(new Error(key + '\u4E0D\u80FD\u4E3A\u7A7A'));
  } else {
    if (RegName.test(value)) {
      callback();
    } else if (rule.field === 'selectedOptions') {
      if (value.length === 0) {
        callback(new Error(key + '\u4E0D\u80FD\u4E3A\u7A7A'));
      } else {
        callback();
      }
    } else {
      callback(new Error(key + '\u683C\u5F0F\u9519\u8BEF'));
    }
  }
};
// 控制长度不控制内容
var VaLength = function VaLength(rule, value, callback) {
  var key = '';
  switch (rule.field) {
    case 'name':
      key = '姓名';
      break;
    case 'id':
      key = '身份证号';
      break;
    case 'groupName':
      key = '企业名称';
      break;
    case 'groupPapersNum':
      key = '企业证件号码';
      break;
    case 'legalName':
      key = '法人姓名';
      break;
    case 'bankAccount':
      key = '对公账户户名';
      break;
    case 'cardno':
      key = '企业对公银行账号';
      break;
    case 'bank':
      key = '企业银行账号开户行名称';
      break;
    case 'subbranch':
      key = '企业银行账号开户行支行全称';
      break;
    case 'selectedOptions':
      key = '企业银行开户行地区';
      break;
  }
  if (!value) {
    callback(new Error(key + '\u4E0D\u80FD\u4E3A\u7A7A'));
  } else {
    if (rule.field === 'groupName' || rule.field === 'bankAccount' || rule.field === 'bank' || rule.field === 'subbranch') {
      if (value.length > 50) {
        callback(new Error(key + '\u683C\u5F0F\u9519\u8BEF,\u957F\u5EA6\u4E0D\u80FD\u8D85\u8FC750'));
      }
    } else if (value.length > 20) {
      callback(new Error(key + '\u683C\u5F0F\u9519\u8BEF,\u957F\u5EA6\u4E0D\u80FD\u8D85\u8FC720'));
    }
  }
};
// 验证普通登录账号
var ValidateGLName = function ValidateGLName(rule, value, callback) {
  var key = '';
  switch (rule.field) {
    case 'phone':
      key = '手机号';
      break;
    case 'mail':
      key = '邮箱号';
      break;
  }
  if (!value) {
    callback(new Error('账号不能为空'));
  } else {
    if (rule.field === 'phone') {
      if (RegexPhone.test(value)) {
        callback();
      } else {
        callback(new Error('手机号格式不正确'));
      }
    } else if (rule.field === 'mail') {
      if (RegEmail.test(value)) {
        callback();
      } else {
        callback(new Error('邮箱号格式不正确'));
      }
    } else {
      if (RegexPhone.test(value) || RegEmail.test(value)) {
        callback();
      } else {
        callback(new Error('账号格式不正确请重新输入'));
      }
    }
  }
};

// 验证普通登录密码
var ValidateGLPassword = function ValidateGLPassword(rule, value, callback) {
  if (!value) {
    callback(new Error('密码不能为空'));
  } else {
    if (RegPass.test(value)) {
      chekPass = value;
      callback();
    } else {
      callback(new Error('必须包含字母和数字，长度为6-20个字符，不支持特殊字符'));
    }
  }
};

// 确认密码
var ValidateChekPassword = function ValidateChekPassword(rule, value, callback) {
  if (!value) {
    callback(new Error('密码不能为空'));
  } else {
    if (chekPass === value) {
      callback();
    } else {
      callback(new Error('两次输入密码不一致!'));
    }
  }
};

// 快速登录 手机验证
var VaPhone = function VaPhone(rule, value, callback) {
  if (!value) {
    callback(new Error('手机号不能为空'));
  } else {
    if (RegexPhone.test(value)) {
      callback();
    } else {
      callback(new Error('手机号格式不正确请重新输入'));
    }
  }
};

// 验证码 验证
var VaCode = function VaCode(rule, value, callback) {
  if (!value) {
    callback(new Error('验证码不能为空'));
  } else {
    if (RegCode.test(value)) {
      callback();
    } else {
      callback(new Error('验证码格式错误，请重新输入'));
    }
  }
};

// 年龄
var IdAge = function IdAge(vaId) {
  var date = new Date();
  var bYear = Number(vaId.substr(6, 4));
  var bMonth = Number(vaId.substr(10, 2));
  var bDate = Number(vaId.substr(12, 2));
  var nYear = Number(date.getFullYear());
  var nMonth = Number(date.getMonth() + 1);
  var nDate = Number(date.getDate());
  if (nDate < bDate) {
    nMonth -= 1;
  }
  if (nMonth < bMonth) {
    nYear -= 1;
  }
  return nYear - bYear;
};

// 身份证验证
var VaId = function VaId(rule, value, callback) {
  var key = '身份证号码';
  switch (rule.field) {
    case 'legalIdno':
      key = '法人身份证号';
      break;
  }
  if (!value) {
    callback(new Error(key + '\u4E0D\u80FD\u4E3A\u7A7A'));
  } else {
    if (RegIdNum.test(value)) {
      if (IdAge(value) < 18) {
        callback(new Error('很遗憾，您未满18周岁，根据国家相关法律法规要求，e签宝暂无法为您提供电子合同服务'));
      } else {
        callback();
      }
    } else {
      callback(new Error('身份证号码错误，请重新输入'));
    }
  }
};

// 银行卡验证
var VaBankNum = function VaBankNum(rule, value, callback) {
  if (!value) {
    callback(new Error('银行卡号不能为空'));
  } else {
    if (value.lenght > 50) {
      callback(new Error('银行卡号错误，请重新输入'));
    }
    if (RegBankNum.test(value) || RegBankNum2.test(value) || RegBankNum3.test(value)) {
      callback();
    } else {
      callback(new Error('银行卡号错误，请重新输入'));
    }
  }
};

// 必须是数字
var VaIsNum = function VaIsNum(rule, value, callback) {
  var key = '金额';
  switch (rule.field) {
    case 'groupPapersNum':
      key = '企业证件号';
      break;
    case 'cardno':
      key = '对公账户';
      break;
  }
  if (!value) {
    callback(new Error(key + '\u4E0D\u80FD\u4E3A\u7A7A'));
  } else {
    if (RegIsNum.test(value)) {
      callback();
    } else {
      callback(new Error(key + '\u683C\u5F0F\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165'));
    }
  }
};

// 用户中心 合同截止日期 校验
var VaIsNumLess1 = function VaIsNumLess1(rule, value, callback) {
  var key = '';
  if (!value) {
    callback(new Error(key + '\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u6700\u5C0F\u662F1'));
  } else {
    if (RegIsNum.test(value)) {
      if (value < 1) {
        callback(new Error('\u6700\u5C0F\u5929\u6570\u662F1'));
      } else if (value > 15) {
        callback(new Error('最大天数15'));
      } else {
        callback();
      }
    } else {
      callback(new Error(key + '\u683C\u5F0F\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165'));
    }
  }
};
// 用户中心 合同有效日期 校验
var VaIsNumLess2 = function VaIsNumLess2(rule, value, callback) {
  var key = '';
  if (!value) {
    callback(new Error(key + '\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u6700\u5C0F\u662F1'));
  } else {
    if (RegIsNum.test(value)) {
      if (value < 1) {
        callback(new Error('\u6700\u5C0F\u5929\u6570\u662F1'));
      } else if (value > 100) {
        callback(new Error('最大天数100'));
      } else {
        callback();
      }
    } else {
      callback(new Error(key + '\u683C\u5F0F\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165'));
    }
  }
};
// 骑缝页面设置 校验
var VaPagingSeal = function VaPagingSeal(rule, value, callback) {
  var key = '';
  if (!value) {
    callback(new Error(key + '\u4E0D\u80FD\u4E3A\u7A7A'));
  } else {
    if (RegIsNum.test(value)) {
      if (value < 1) {
        callback(new Error('\u6700\u5C0F\u9875\u6570\u662F1'));
      } else {
        callback();
      }
    } else {
      callback(new Error(key + '\u683C\u5F0F\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165'));
    }
  }
};

// 不能为空
var VaIsBlank = function VaIsBlank(rule, value, callback) {
  var key = '';
  switch (rule.field) {
    case 'password':
      key = '密码';
      break;
    case 'bankNum':
      key = '开户银行账号';
  }
  if (rule.field === 'password') {
    if (!value) {
      callback(new Error(key + '\u4E0D\u80FD\u4E3A\u7A7A'));
    } else {
      callback();
    }
  } else if (rule.field === 'bankNum') {
    if (!value) {
      callback(new Error(key + '\u4E0D\u80FD\u4E3A\u7A7A'));
    }
    if (value.length > 50) {
      callback(new Error(key + '\u957F\u5EA6\u4E0D\u80FD\u8D85\u8FC750'));
    }
    if (/^[A-Za-z0-9]+$/.test(value)) {
      callback();
    } else {
      callback(new Error(key + '\u683C\u5F0F\u4E0D\u6B63\u786E'));
    }
  }
};

// checkbox 选择不能为空
var VaCheckboxBlank = function VaCheckboxBlank(rule, value, callback) {
  var key = '';
  switch (rule.field) {
    case 'organType':
      key = '企业类型';
      break;
    case 'licenseType':
      key = '证件类型';
      break;
    case 'legalArea':
      key = '法人代表归属地';
      break;
    case 'userType':
      key = '填写人身份';
      break;
  }
  if (value === '' || value.length === 0) {
    callback(new Error(key + '\u4E0D\u80FD\u4E3A\u7A7A'));
  } else {
    callback();
  }
};
// 上传图片不能为空
var VaPhotoBlank = function VaPhotoBlank(rule, value, callback) {
  var key = '';
  switch (rule.field) {
    case 'organType':
      key = '企业类型';
      break;
    case 'licenseType':
      key = '证件类型';
      break;
    case 'legalArea':
      key = '法人代表归属地';
      break;
    case 'userType':
      key = '填写人身份';
      break;
  }
  if (value === '') {
    callback(new Error(key + '\u4E0D\u80FD\u4E3A\u7A7A'));
  } else {
    callback();
  }
};
// 验证邮箱和手机号
var checkPhoneEmail = function checkPhoneEmail(rule, value, callback) {
  if (!value) {
    callback(new Error('手机号或邮箱不能为空'));
  } else {
    if (value.length > 36) {
      callback(new Error('手机号或邮箱最大长度不超过36个字符'));
    }
    if (RegexPhone.test(value) || RegEmail.test(value)) {
      callback();
    } else {
      callback(new Error('请输入正确的手机号／邮箱号'));
    }
  }
};

// 验证企业名称／姓名
var checkNickName = function checkNickName(rule, value, callback) {
  if (!value) {
    callback(new Error('请输入企业名称／姓名'));
  } else {
    if (value.length < 2 || value.length > 80) {
      callback(new Error('企业名称／姓名长度在 2 到 80 个字符'));
    } else {
      callback();
    }
  }
};

// 个人自动实名 姓名 validate
var personalRealName = function personalRealName(rule, value, callback) {
  if (!value) {
    callback(new Error('姓名不能为空'));
  } else {
    if (value.length < 2 || value.length > 80) {
      callback(new Error('姓名长度在 2 到 80 个字符'));
    } else {
      callback();
    }
  }
};

// 非三证合一 组织机构代码
var RegOrganCode = /^([0-9A-Z]){8}[-]?[0-9A-Z]$/;
var checkOrganCode = function checkOrganCode(rule, value, callback) {
  if (!value) {
    callback(new Error('请输入组织机构代码'));
  } else {
    if (RegOrganCode.test(value)) {
      callback();
    } else {
      callback(new Error('请输入正确的组织机构代码'));
    }
  }
};

// 三证合一 统一社会信用代码
// const RegOrganCode3 = /^\d{18}$/;
var RegOrganCode3 = /^([0-9A-Z]{2})([0-9]{6})([0-9A-Z]){10}$/;
var checkOrganCode3 = function checkOrganCode3(rule, value, callback) {
  var key = '';
  switch (rule.field) {
    case 'organCodeThree':
      key = '统一社会信用代码';
  }
  if (!value) {
    callback(new Error('\u8BF7\u8F93\u5165' + key));
  } else {
    if (RegOrganCode3.test(value)) {
      callback();
    } else {
      callback(new Error('\u8BF7\u8F93\u5165\u6B63\u786E\u7684' + key));
    }
  }
};
// 工商注册号 regCode
// const RegRegCode = /^\d{15}$/;
var RegRegCode = /^\w{0,40}$/;
var checkRegCode = function checkRegCode(rule, value, callback) {
  var key = '';
  switch (rule.field) {
    case 'regCode0':
      key = '注册号';
      break;
    case 'regCode1':
      key = '社证号';
      break;
    case 'regCode2':
      key = '事证号';
      break;
    case 'regCode3':
      key = '民证字号';
      break;
    case 'regCode4':
      key = '执法证号';
      break;
  }
  if (!value) {
    callback(new Error('\u8BF7\u8F93\u5165' + key));
  } else {
    if (RegRegCode.test(value)) {
      callback();
    } else {
      callback(new Error('\u8BF7\u8F93\u5165\u6B63\u786E\u7684' + key));
    }
  }
};

// 长度校验 1 - 50
var checkNameLength = function checkNameLength(rule, value, callback) {
  var key = '';
  switch (rule.field) {
    case 'name':
      key = '姓名';
      break;
    case 'bank':
      key = '开户银行';
      break;
    case 'subbranch':
      key = '开户银行支行名称';
      break;
    case 'legalName':
      key = '法定代表人姓名';
      break;
    case 'groupname':
      key = '企业名称';
      break;
    case 'agentName':
      key = '代理人姓名';
      break;
    case 'bankNum':
      key = '对公账户';
      break;
  }
  if (!value) {
    callback(new Error('\u8BF7\u8F93\u5165' + key));
  } else {
    if (rule.field === 'name' || rule.field === 'legalName' || rule.field === 'agentName') {
      if (value.length < 2 || value.length > 20) {
        callback(new Error(key + '\u957F\u5EA6\u5728 2 \u5230 20 \u4E2A\u5B57\u7B26'));
      } else {
        callback();
      }
    } else {
      if (value.length < 2 || value.length > 50) {
        callback(new Error(key + '\u957F\u5EA6\u5728 2 \u5230 50 \u4E2A\u5B57\u7B26'));
      } else {
        callback();
      }
    }
  }
};
// 长度校验 1 - 50
var checkNameLength2 = function checkNameLength2(rule, value, callback) {
  var key = '';
  switch (rule.field) {
    case 'bankAccount':
      key = '企业对公账户户名';
      break;
    case 'bankNum':
      key = '对公账户';
      break;
    case 'subbranch':
      key = '企业银行账号开户支行全称';
      break;
    case 'bank':
      key = '企业银行开户行名称';
      break;
  }
  if (!value) {
    callback(new Error('\u8BF7\u8F93\u5165' + key));
  } else {
    if (rule.field === 'bankNum') {
      if (!/^\d{1,50}$/.test(value)) {
        callback(new Error(key + '\u957F\u5EA6\u5728 2 \u5230 50 \u4E2A\u5B57\u7B26'));
      } else {
        callback();
      }
    } else {
      if (value.length < 2 || value.length > 50) {
        callback(new Error(key + '\u957F\u5EA6\u5728 2 \u5230 50 \u4E2A\u5B57\u7B26'));
      } else {
        callback();
      }
    }
  }
};

// 长度校验 1 - 50  企业实名
var checkNameLength3 = function checkNameLength3(rule, value, callback) {
  var key = '';
  switch (rule.field) {
    case 'groupName':
      key = '企业名称';
      break;
    case 'legalName':
      key = '法人姓名';
      break;
    case 'bankAccount':
      key = '对公账户户名';
      break;
    case 'cardno':
      key = '对公账户';
      break;
    case 'subbranch':
      key = '开户行支行名称';
      break;
    case 'bank':
      key = '开户行名称';
      break;
    case 'legalIdno':
      key = '法人身份证号';
      break;
    case 'legalIdNo':
      key = '法人身份证号';
      break;
    case 'codeUSC':
      key = '统一社会信用代码';
      break;
    case 'codeORG':
      key = '组织机构代码';
      break;
    case 'selectedOptions':
      key = '开户行支行所在地';
      break;
  }
  if (!value) {
    if (rule.field === 'legalIdno') {
      callback();
    } else {
      callback(new Error('\u8BF7\u8F93\u5165' + key));
    }
  } else {
    if (rule.field === 'cardno') {
      if (!RegIsNum.test(value)) {
        callback(new Error(key + '\u683C\u5F0F\u4E0D\u6B63\u786E'));
      } else {
        callback();
      }
    } else if (rule.field === 'legalName') {
      if (value.length < 2 || value.length > 30) {
        callback(new Error(key + '\u957F\u5EA6\u5728 2 \u5230 30 \u4E2A\u5B57\u7B26'));
      } else {
        callback();
      }
    } else if (rule.field === 'codeUSC') {
      if (!RegOrganCode3.test(value)) {
        callback(new Error(key + '\u683C\u5F0F\u4E0D\u6B63\u786E'));
      } else {
        callback();
      }
    } else if (rule.field === 'codeORG') {
      if (!RegOrganCode.test(value)) {
        callback(new Error(key + '\u683C\u5F0F\u4E0D\u6B63\u786E'));
      } else {
        callback();
      }
    } else if (rule.field === 'legalIdno') {
      if (!RegIdNum.test(value)) {
        callback(new Error(key + '\u683C\u5F0F\u4E0D\u6B63\u786E'));
      } else {
        callback();
      }
    } else if (rule.field === 'legalIdNo') {
      if (!RegIdNum.test(value)) {
        callback(new Error(key + '\u683C\u5F0F\u4E0D\u6B63\u786E'));
      } else {
        callback();
      }
    } else if (rule.field === 'selectedOptions') {
      if (value.length === 0) {
        callback(new Error(key + '\u4E0D\u80FD\u4E3A\u7A7A'));
      } else {
        callback();
      }
    } else {
      if (value.length < 2 || value.length > 60) {
        callback(new Error(key + '\u957F\u5EA6\u5728 2 \u5230 60\u4E2A\u5B57\u7B26'));
      } else {
        callback();
      }
    }
  }
};
// 香港
var RegHkId = /^[Hh]{1}([0-9]{10}|[0-9]{8})$/;
// 澳门
var RegAmId = /^[Mm]{1}([0-9]{10}|[0-9]{8})$/;
// 台湾
var RegTwId1 = /^[0-9]{8}$/;
var RegTwId2 = /^[0-9]{10}$/;
// 护照
var Reghuz = /^[A-Za-z0-9]+$/;
// 实名 id 校验
var checkSmId = function checkSmId(rule, value, callback) {
  var key = '';
  switch (rule.field) {
    case 'idNo':
      key = '身份证号码';
      break;
    case 'idNoHk':
      key = '内地通行证';
      break;
    case 'idNoAm':
      key = '内地通行证';
      break;
    case 'idNoTw':
      key = '台胞证';
      break;
    case 'idNoWj':
      key = '护照';
      break;
    case 'legalIdNo':
      key = '身份证号码';
      break;
    case 'legalIdNoHK':
      key = '内地通行证';
      break;
    case 'legalIdNoAM':
      key = '内地通行证';
      break;
    case 'legalIdNoTW':
      key = '台胞证';
      break;
    case 'legalIdNoWJ':
      key = '护照';
      break;
  }
  if (!value) {
    callback(new Error('\u8BF7\u8F93\u5165' + key));
  } else {
    if (rule.field === 'idNo' || rule.field === 'legalIdNo') {
      if (RegIdNum.test(value)) {
        callback();
      } else {
        callback(new Error('\u8BF7\u8F93\u5165\u6B63\u786E' + key));
      }
    } else if (rule.field === 'idNoHk' || rule.field === 'legalIdNoHK') {
      if (RegHkId.test(value)) {
        callback();
      } else {
        callback(new Error('\u8BF7\u8F93\u5165\u6B63\u786E' + key));
      }
    } else if (rule.field === 'idNoAm' || rule.field === 'legalIdNoAM') {
      if (RegAmId.test(value)) {
        callback();
      } else {
        callback(new Error('\u8BF7\u8F93\u5165\u6B63\u786E' + key));
      }
    } else if (rule.field === 'idNoTw' || rule.field === 'legalIdNoTW') {
      if (RegTwId1.test(value) || RegTwId2.test(value)) {
        callback();
      } else {
        callback(new Error('\u8BF7\u8F93\u5165\u6B63\u786E' + key));
      }
    } else if (rule.field === 'idNoWj' || rule.field === 'legalIdNoWJ') {
      if (Reghuz.test(value)) {
        callback();
      } else {
        callback(new Error('\u8BF7\u8F93\u5165\u6B63\u786E' + key));
      }
    }
  }
};

// 企业 打款金额 校验
// 匹配数值类型，包括整数和浮点数
var RegCheckPay1 = /^[-\+]?\d+$/;
var RegCheckPay2 = /^[-\+]?\d+(\.\d+)?$/;
var checkPay = function checkPay(rule, value, callback) {
  if (!value) {
    callback(new Error('请输入金额'));
  } else {
    if (RegCheckPay1.test(value) || RegCheckPay2.test(value)) {
      callback();
    } else {
      callback(new Error('金额格式输入不正确'));
    }
  }
};
// 添加 印章
var checkPersonSeal = function checkPersonSeal(rule, value, callback) {
  var key = '';
  switch (rule.field) {
    case 'personName':
      key = '姓名';
      break;
    case 'legalPersonName':
      key = '法人姓名';
      break;
    case 'groupName':
      key = '企业名称';
      break;
    case 'name':
      key = '印章名称';
      break;
    case 'Uses':
      key = '印章使用人';
      break;
    case 'Audits':
      key = '印章审计人';
      break;
  }
  if (!value) {
    callback(new Error(key + '\u4E0D\u80FD\u4E3A\u7A7A'));
  } else {
    if (rule.field === 'personName' || rule.field === 'legalPersonName') {
      if (value.length < 2 || value.length > 18) {
        callback(new Error(key + '\u957F\u5EA6\u5728 2 \u5230 18 \u4E2A\u5B57\u7B26'));
      } else {
        callback();
      }
    } else if (rule.field === 'name') {
      if (value.length < 2 || value.length > 15) {
        callback(new Error(key + '\u957F\u5EA6\u5728 2 \u5230 15 \u4E2A\u5B57\u7B26'));
      } else {
        callback();
      }
    } else if (rule.field === 'groupName') {
      if (value.length < 2 || value.length > 60) {
        callback(new Error(key + '\u957F\u5EA6\u5728 2 \u5230 60 \u4E2A\u5B57\u7B26'));
      } else {
        callback();
      }
    } else {
      if (RegexPhone.test(value) || RegEmail.test(value)) {
        callback();
      } else {
        callback(new Error(key + '\u683C\u5F0F\u4E3A\u624B\u673A\u53F7\u6216\u90AE\u7BB1\u53F7'));
      }
    }
  }
};

// 印章上传 宽高校验 RegPINum
var checkSealWH = function checkSealWH(rule, value, callback) {
  var key = '';
  switch (rule.field) {
    case 'width':
      key = '宽度';
      break;
    case 'height':
      key = '高度';
      break;
  }
  if (!value) {
    callback(new Error(key + '\u4E0D\u80FD\u4E3A\u7A7A'));
  } else {
    if (RegPINum.test(value)) {
      if (value <= 100) {
        callback();
      } else {
        callback(new Error('仅支持100mm以内的印章'));
      }
    } else {
      callback(new Error(key + '\u683C\u5F0F\u9519\u8BEF'));
    }
  }
};

var fileName = function fileName(rule, value, callback) {
  if (!value) {
    callback(new Error('名称不能为空'));
  } else {
    if (value.length <= 20) {
      callback();
    } else {
      callback(new Error('名称不能超出20个字符'));
    }
  }
};
// EXTERNAL MODULE: ./src/pages/admin/assets/layout.less
var layout = __webpack_require__("GbM2");
var layout_default = /*#__PURE__*/__webpack_require__.n(layout);

// CONCATENATED MODULE: ./src/pages/admin/main.js
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// 兼容












// 百度埋点

// api 请求

// 饿了么 表单验证

// 全局


// ** 引入动画
// import '@lib/transitions.js';

Object(vuex_router_sync["sync"])(store, admin_router);
// this.$message({customClass: 'el-msg--error', message: '', type: 'error'});
// this.$message({customClass: 'el-msg--success', message: '', type: 'success'});

if (true) {
  // arms
  var BrowerLogger = __webpack_require__("obvJ");
  var __bl = BrowerLogger.singleton({
    pid: 'fkmlak58tj@e717308128fe396',
    imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
    tag: '标准签',
    enableSPA: true,
    disableHook: true,
    useFmp: true,
    sendResource: true
  });
}

// fundebug
// const fundebug = require('fundebug-javascript');

// fundebug.apikey = '7d07b7b2a31a6b8d5d3250a4b46c0e59289ee2307a3dbf732bd4f0d577e9cdfe';

// function formatComponentName(vm) {
//   if (vm.$root === vm) return 'root';

//   var name = vm._isVue ? (vm.$options && vm.$options.name) || (vm.$options && vm.$options._componentTag) : vm.name;
//   return (name ? 'component <' + name + '>' : 'anonymous component') + (vm._isVue && vm.$options && vm.$options.__file ? ' at ' + (vm.$options && vm.$options.__file) : '');
// }

// Vue.config.errorHandler = function(err, vm, info) {
//   var componentName = formatComponentName(vm);
//   var propsData = vm.$options && vm.$options.propsData;

//   fundebug.notifyError(err,
//   {
//       metaData:
//       {
//           componentName: componentName,
//           propsData: propsData,
//           info: info
//       }
//    });
// };

// ** Vue注入组件-
vue_esm["default"].use(element_ui_common_default.a);
vue_esm["default"].use(install);
// 全局引入vue-jsonp
vue_esm["default"].use(vue_jsonp_umd_default.a);
// 百度统计
vue_esm["default"].prototype.trackEvent = trackEvent;
// 接口请求api
vue_esm["default"].prototype.$api = resource_api;
// 校验
vue_esm["default"].prototype.$vla = eleValidate_namespaceObject;
// axios http拦截
Object(resource["a" /* default */])();
vue_esm["default"].config.productionTip = false;
vue_esm["default"].config.devtools = true;
/* eslint-disable no-new */
/**
 * 创建vue实例
 * 在这里注入 router  store 到所有的子组件
 * 这样就可以在任何地方使用 `this.$router` and `this.$store`
 */
new vue_esm["default"]({
  el: '#app',
  store: store,
  router: admin_router,
  render: function render(h) {
    return h(pages_admin_App);
  }
});

/***/ }),

/***/ "mA+V":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAgRJREFUSA21Vr1qAkEQ3vtBsbAURIIE06S2UnwEISF9mrxAIE8Q8gSB1IJN+mDARxCtrAMSCRLFxspCBE/zfcvuZe+8O42ahWVnZr/5Zn/mds4SCa3X652t1+trQOqbzeYCY0HBJ5ZlfUJu27bdqlQq38q+NVhbFhj6/X5hsVg8QbxDd6Iwhs2D3MxkMo/lcnli2KW4FaDb7V5h1a+YzYbBO/Q5dnNbrVbfTZxtKp1O5x5H8QbbX8lJk6UvOUxOfwdcOQHogaAa7LquKBaLUh2NRmK1WumpwIi7WaPf6J3IAOrMP4CMXXmpVBL5fF6STadTMRwOA8QhZY47ueSdyNWqC40lDznvo2YVp7CYip7nfcErMVv2PSIjuuc4zrmr8jyRnE488x3HYnBL0SG3C7EenonS0+l04A6Wy2UULGyru8gafqE7GzMol8tJXCqVEoPBYKcPuXnJ+vNPdOAd6GbK2hYzFiJzPgZ8kJkBtt6Pg5iinSa2ehWjp4+0kps7aB/Jk+TO59xuAcEn99TNI7etikXz1Ozga5JbZhGLBQzzpCD4Kv1pU/aNQYGPHTmFDCBfPRQLPrVB3K82Ho/FbDaTnXJcIwcLj65ufj2gA4sFAM9xNSGOVNtJDt+HWq324tu0oMd/LZkMwkrEYgGxgb5PdhHToI+uYtD9Fjgi36qEU/y2/ABEJM/WFPk4YQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "rvz5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export apiBaseFn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PROTOCOL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HOST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _API; });
/* unused harmony export LOCAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SOURCE; });
/* unused harmony export OSSASSET */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/**
 * 定义请求地址
 * @param local：本地mock
 * @param develop: 本地开发
 * @param feature: 测试环境
 * @param prepub: 预发环境
 * @param production: 线上环境
 **/


var config = {
  local: 'http://127.0.0.1:3000/api',
  // develop: '120.26.93.6:8084',
  develop: '121.40.239.205:8000',
  feature: '121.40.239.205:8000',
  prepub: 'preapi.tsign.cn',
  production: 'api.tsign.cn'
};

var customConfig = {
  'esign': ['localhost', 'web.dev.cn', 'test.web.tsign.cn', 'preweb.tsign.cn', 'web.tsign.cn'],
  'yonyou': ['yonyoutest.web.tsign.cn', 'yonyouweb.tsign.cn', 'yonyoupreweb.tsign.cn']
};

var oss = 'https://asset.tsign.cn';

var DEVELOP = false || false;
var FEATURE = false || false;
var PREPUB = false || false;
var PRODUCTION = true || false;

var apiBaseFn = function apiBaseFn() {
  if (DEVELOP) {
    // 本地环境
    return config.develop;
  }
  if (FEATURE) {
    // 测试环境
    return config.feature;
  }
  if (PREPUB) {
    // 预发环境
    return config.prepub;
  }
  if (PRODUCTION) {
    // 线上环境
    return config.production;
  }
};

var apiProtocol = function apiProtocol() {
  if (DEVELOP || FEATURE) {
    return 'http://';
  }
  if (PREPUB || PRODUCTION) {
    // 测试环境
    return 'https://';
  }
};

// let api = () => {
//     if (DEVELOP || FEATURE ||  PRODUCTION || PREPUB) {
//        return apiProtocol() + apiBaseFn() + '/service';
//     } else {
//         return config.local;
//     }
// };

var api = function api() {
  if (DEVELOP || FEATURE) {
    return 'http://' + apiBaseFn() + '/service';
  } else if (PREPUB || PRODUCTION) {
    return 'https://' + apiBaseFn() + '/service';
  } else {
    return config.local;
  }
};

var _api = function _api() {
  if (DEVELOP || FEATURE) {
    return 'http://' + apiBaseFn();
  } else if (PREPUB || PRODUCTION) {
    return 'https://' + apiBaseFn();
  } else {
    return config.local;
  }
};

var customSource = function customSource() {

  var hostname = window.location.hostname;
  //
  // const customizeInfo = JSON.parse(window.sessionStorage.getItem('customizeInfo'));
  // if (customizeInfo && customizeInfo['orgId']) {
  //     return customizeInfo['orgId'];
  // };

  var sourcename = 'esign';
  // ip 地址全部走 ‘esign’
  var reg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/; // ip地址
  if (reg.test(hostname)) {
    return sourcename;
  }
  // 域名
  for (var source in customConfig) {
    if (customConfig[source].indexOf(hostname) > -1) {
      sourcename = source;
      break;
    }
    // for (let i = 0; i < customConfig[source].length; i++){
    //     if (customConfig[source][i] == hostname){
    //         sourcename = source;
    //         break;
    //     }
    // }
  }
  return sourcename;
};

/**
 * oss 静态资源 通用部分地址
 */
var ossAsset = function ossAsset() {
  /**
   * 线上 + 预发
   */
  if (PREPUB || PRODUCTION) {
    return oss + '/common';
  }
  /**
   * 本地 + 测试
   */
  return '/static';
};

var PROTOCOL = apiProtocol();
var HOST = apiBaseFn();
var API = api();
var _API = _api();
var LOCAL = config.local;
var SOURCE = customSource();
var OSSASSET = ossAsset();



/***/ })

},["lGzU"]);


// WEBPACK FOOTER //
// production/v2.18.15/js/admin.7799ab0a7d9edeadd6ff.js